//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export interface IManualTaskSchedulingClient {
    triggerJob(job: string): Promise<FileResponse>;
}

export class ManualTaskSchedulingClient implements IManualTaskSchedulingClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";

    }

    triggerJob(job: string , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/manual-task-scheduling/trigger-job/{job}";
        if (job === undefined || job === null)
            throw new Error("The parameter 'job' must be defined.");
        url_ = url_.replace("{job}", encodeURIComponent("" + job));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTriggerJob(_response);
        });
    }

    protected processTriggerJob(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IBillingClient {
    beginPaymentForBookingCreating(requestDTO: BeginPaymentForBookingCreatingRequestDTO): Promise<ControllerActionResultOfBeginPaymentResponseDTO>;
    hasBillingOrderBeenPaid(request: HasBillingOrderBeenPaidRequestDTO): Promise<HasBillingOrderBeenPaidResponseDTO>;
}

export class BillingClient implements IBillingClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";

    }

    beginPaymentForBookingCreating(requestDTO: BeginPaymentForBookingCreatingRequestDTO , cancelToken?: CancelToken | undefined): Promise<ControllerActionResultOfBeginPaymentResponseDTO> {
        let url_ = this.baseUrl + "/billing/begin-payment-for-booking-creating";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBeginPaymentForBookingCreating(_response);
        });
    }

    protected processBeginPaymentForBookingCreating(response: AxiosResponse): Promise<ControllerActionResultOfBeginPaymentResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ControllerActionResultOfBeginPaymentResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ControllerActionResultOfBeginPaymentResponseDTO>(null as any);
    }

    hasBillingOrderBeenPaid(request: HasBillingOrderBeenPaidRequestDTO , cancelToken?: CancelToken | undefined): Promise<HasBillingOrderBeenPaidResponseDTO> {
        let url_ = this.baseUrl + "/billing/has-billing-order-been-paid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHasBillingOrderBeenPaid(_response);
        });
    }

    protected processHasBillingOrderBeenPaid(response: AxiosResponse): Promise<HasBillingOrderBeenPaidResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<HasBillingOrderBeenPaidResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HasBillingOrderBeenPaidResponseDTO>(null as any);
    }
}

export interface IBillingOrderClient {
    summary(request: ReadBillingOrderSummaryRequestDTO): Promise<BillingOrderSummaryVDTO>;
}

export class BillingOrderClient implements IBillingOrderClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";

    }

    summary(request: ReadBillingOrderSummaryRequestDTO , cancelToken?: CancelToken | undefined): Promise<BillingOrderSummaryVDTO> {
        let url_ = this.baseUrl + "/billing-order/summary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSummary(_response);
        });
    }

    protected processSummary(response: AxiosResponse): Promise<BillingOrderSummaryVDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BillingOrderSummaryVDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BillingOrderSummaryVDTO>(null as any);
    }
}

export interface IBookingObjectCalendarClient {
    create(requestDTO: CreateBookingObjectCalendarRequestDTO): Promise<ControllerActionResultOfGuid>;
    closeDates(requestDTO: CloseDatesRequestDTO): Promise<ControllerActionResultOfGuid>;
    updateClosedDatesEvent(requestDTO: UpdateClosedDatesEventRequestDTO): Promise<EmptyControllerActionResult>;
    deleteEvent(requestDTO: DeleteBookingObjectCalendarEventRequestDTO): Promise<EmptyControllerActionResult>;
    isSynchronizationSetup(options: IsSynchronizationSetUpRequestDTO): Promise<boolean>;
    readForBookingObject(requestDTO: ReadCalendarForBookingObjectRequestDTO): Promise<BookingObjectCalendarVDTO>;
    readForBookingObjects(requestDTO: ReadCalendarsForBookingObjectsRequestDTO): Promise<BookingObjectCalendarVDTO[]>;
    readCalendarStates(requestDTO: ReadBookingObjectCalendarStatesRequestDTO): Promise<PagedReadingResultOfBookingObjectCalendarStateVDTO>;
    readOccupancySynchronizationStatistics(): Promise<OccupancySynchronizationStatisticsVDTO>;
}

export class BookingObjectCalendarClient implements IBookingObjectCalendarClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";

    }

    create(requestDTO: CreateBookingObjectCalendarRequestDTO , cancelToken?: CancelToken | undefined): Promise<ControllerActionResultOfGuid> {
        let url_ = this.baseUrl + "/booking-object/calendar/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ControllerActionResultOfGuid> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ControllerActionResultOfGuid>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ControllerActionResultOfGuid>(null as any);
    }

    closeDates(requestDTO: CloseDatesRequestDTO , cancelToken?: CancelToken | undefined): Promise<ControllerActionResultOfGuid> {
        let url_ = this.baseUrl + "/booking-object/calendar/close-dates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCloseDates(_response);
        });
    }

    protected processCloseDates(response: AxiosResponse): Promise<ControllerActionResultOfGuid> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ControllerActionResultOfGuid>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ControllerActionResultOfGuid>(null as any);
    }

    updateClosedDatesEvent(requestDTO: UpdateClosedDatesEventRequestDTO , cancelToken?: CancelToken | undefined): Promise<EmptyControllerActionResult> {
        let url_ = this.baseUrl + "/booking-object/calendar/update-closed-dates-event";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateClosedDatesEvent(_response);
        });
    }

    protected processUpdateClosedDatesEvent(response: AxiosResponse): Promise<EmptyControllerActionResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EmptyControllerActionResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyControllerActionResult>(null as any);
    }

    deleteEvent(requestDTO: DeleteBookingObjectCalendarEventRequestDTO , cancelToken?: CancelToken | undefined): Promise<EmptyControllerActionResult> {
        let url_ = this.baseUrl + "/booking-object/calendar/delete-event";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteEvent(_response);
        });
    }

    protected processDeleteEvent(response: AxiosResponse): Promise<EmptyControllerActionResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EmptyControllerActionResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyControllerActionResult>(null as any);
    }

    isSynchronizationSetup(options: IsSynchronizationSetUpRequestDTO , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/booking-object/calendar/is-synchronization-setup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsSynchronizationSetup(_response);
        });
    }

    protected processIsSynchronizationSetup(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    readForBookingObject(requestDTO: ReadCalendarForBookingObjectRequestDTO , cancelToken?: CancelToken | undefined): Promise<BookingObjectCalendarVDTO> {
        let url_ = this.baseUrl + "/booking-object/calendar/read-for-booking-object";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadForBookingObject(_response);
        });
    }

    protected processReadForBookingObject(response: AxiosResponse): Promise<BookingObjectCalendarVDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BookingObjectCalendarVDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingObjectCalendarVDTO>(null as any);
    }

    readForBookingObjects(requestDTO: ReadCalendarsForBookingObjectsRequestDTO , cancelToken?: CancelToken | undefined): Promise<BookingObjectCalendarVDTO[]> {
        let url_ = this.baseUrl + "/booking-object/calendar/read-for-booking-objects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadForBookingObjects(_response);
        });
    }

    protected processReadForBookingObjects(response: AxiosResponse): Promise<BookingObjectCalendarVDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BookingObjectCalendarVDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingObjectCalendarVDTO[]>(null as any);
    }

    readCalendarStates(requestDTO: ReadBookingObjectCalendarStatesRequestDTO , cancelToken?: CancelToken | undefined): Promise<PagedReadingResultOfBookingObjectCalendarStateVDTO> {
        let url_ = this.baseUrl + "/booking-object/calendar/read-calendar-states";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadCalendarStates(_response);
        });
    }

    protected processReadCalendarStates(response: AxiosResponse): Promise<PagedReadingResultOfBookingObjectCalendarStateVDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PagedReadingResultOfBookingObjectCalendarStateVDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedReadingResultOfBookingObjectCalendarStateVDTO>(null as any);
    }

    readOccupancySynchronizationStatistics(cancelToken?: CancelToken | undefined): Promise<OccupancySynchronizationStatisticsVDTO> {
        let url_ = this.baseUrl + "/booking-object/calendar/occupancy-synchronization-statistics";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadOccupancySynchronizationStatistics(_response);
        });
    }

    protected processReadOccupancySynchronizationStatistics(response: AxiosResponse): Promise<OccupancySynchronizationStatisticsVDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<OccupancySynchronizationStatisticsVDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OccupancySynchronizationStatisticsVDTO>(null as any);
    }
}

export interface IBookingObjectCalendarExternalSourceClient {
    create(requestDTO: CreateBookingObjectCalendarExternalSourceRequestDTO): Promise<ControllerActionResultOfGuid>;
    delete(requestDTO: DeleteBookingObjectCalendarExternalSourceRequestDTO): Promise<EmptyControllerActionResult>;
    reactivate(requestDTO: ReactivateBookingObjectCalendarExternalSourceRequestDTO): Promise<EmptyControllerActionResult>;
    reactivateAllStopped(): Promise<ControllerActionResultOfInt32>;
}

export class BookingObjectCalendarExternalSourceClient implements IBookingObjectCalendarExternalSourceClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";

    }

    create(requestDTO: CreateBookingObjectCalendarExternalSourceRequestDTO , cancelToken?: CancelToken | undefined): Promise<ControllerActionResultOfGuid> {
        let url_ = this.baseUrl + "/booking-object/calendar/external-source/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ControllerActionResultOfGuid> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ControllerActionResultOfGuid>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ControllerActionResultOfGuid>(null as any);
    }

    delete(requestDTO: DeleteBookingObjectCalendarExternalSourceRequestDTO , cancelToken?: CancelToken | undefined): Promise<EmptyControllerActionResult> {
        let url_ = this.baseUrl + "/booking-object/calendar/external-source/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<EmptyControllerActionResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EmptyControllerActionResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyControllerActionResult>(null as any);
    }

    reactivate(requestDTO: ReactivateBookingObjectCalendarExternalSourceRequestDTO , cancelToken?: CancelToken | undefined): Promise<EmptyControllerActionResult> {
        let url_ = this.baseUrl + "/booking-object/calendar/external-source/reactivate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReactivate(_response);
        });
    }

    protected processReactivate(response: AxiosResponse): Promise<EmptyControllerActionResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EmptyControllerActionResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyControllerActionResult>(null as any);
    }

    reactivateAllStopped(cancelToken?: CancelToken | undefined): Promise<ControllerActionResultOfInt32> {
        let url_ = this.baseUrl + "/booking-object/calendar/external-source/reactivate-all-stopped";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReactivateAllStopped(_response);
        });
    }

    protected processReactivateAllStopped(response: AxiosResponse): Promise<ControllerActionResultOfInt32> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ControllerActionResultOfInt32>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ControllerActionResultOfInt32>(null as any);
    }
}

export interface IBookingObjectCalendarHubClient {
    ics(id: string): Promise<FileResponse>;
}

export class BookingObjectCalendarHubClient implements IBookingObjectCalendarHubClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";

    }

    ics(id: string , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/booking-object/calendar/hub/ics/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIcs(_response);
        });
    }

    protected processIcs(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IBookingObjectClient {
    create(options: CreateBookingObjectOptionsDTO): Promise<ControllerActionResultOfBookingObjectCreateResultVDTO>;
    update(options: UpdateBookingObjectDTO): Promise<ControllerActionResultOfBookingObjectUpdateResultVDTO>;
    activate(requestDTO: ActivateBookingObjectRequestDTO): Promise<EmptyControllerActionResult>;
    manageBookingType(requestDTO: ManageBookingTypeRequestDTO): Promise<EmptyControllerActionResult>;
    capacity(requestDTO: ReadBookingObjectCapacityRequestDTO): Promise<BookingObjectCapacityResponseDTO>;
    summaryForOccupancySchedule(requestDTO: ReadBookingObjectSummaryForOccupancyScheduleRequestDTO): Promise<BookingObjectSummaryForOccupancyScheduleVDTO>;
    summariesForOccupancySchedule(requestDTO: ReadBookingObjectSummariesForOccupancyScheduleRequestDTO): Promise<BookingObjectSummaryForOccupancyScheduleVDTO[]>;
    summaryForPricePolicyManagement(requestDTO: ReadBookingObjectSummaryForPricePolicyManagementRequestDTO): Promise<BookingObjectSummaryForPricePolicyManagementVDTO>;
    get(id?: string | undefined): Promise<BookingObjectDTO>;
    mine(): Promise<BookingObjectSummaryVDTO[]>;
    summariesForUser(requestDTO: ReadBookingObjectSummariesForUserRequestDTO): Promise<BookingObjectSummaryVDTO[]>;
    summariesForFavorites(options: ReadBookingObjectSummaryForFavoritesRequestDTO): Promise<BookingObjectSummaryVDTO[]>;
    byUser(requestDTO: ReadBookingObjectsForUserRequestDTO): Promise<BookingObjectsForUserVDTO>;
    structure(requestDTO: ReadBookingObjectsStructureForUserRequestDTO): Promise<BookingObjectStructureVDTO[]>;
}

export class BookingObjectClient implements IBookingObjectClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";

    }

    create(options: CreateBookingObjectOptionsDTO , cancelToken?: CancelToken | undefined): Promise<ControllerActionResultOfBookingObjectCreateResultVDTO> {
        let url_ = this.baseUrl + "/booking-object/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ControllerActionResultOfBookingObjectCreateResultVDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ControllerActionResultOfBookingObjectCreateResultVDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ControllerActionResultOfBookingObjectCreateResultVDTO>(null as any);
    }

    update(options: UpdateBookingObjectDTO , cancelToken?: CancelToken | undefined): Promise<ControllerActionResultOfBookingObjectUpdateResultVDTO> {
        let url_ = this.baseUrl + "/booking-object/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<ControllerActionResultOfBookingObjectUpdateResultVDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ControllerActionResultOfBookingObjectUpdateResultVDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ControllerActionResultOfBookingObjectUpdateResultVDTO>(null as any);
    }

    activate(requestDTO: ActivateBookingObjectRequestDTO , cancelToken?: CancelToken | undefined): Promise<EmptyControllerActionResult> {
        let url_ = this.baseUrl + "/booking-object/activate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActivate(_response);
        });
    }

    protected processActivate(response: AxiosResponse): Promise<EmptyControllerActionResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EmptyControllerActionResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyControllerActionResult>(null as any);
    }

    manageBookingType(requestDTO: ManageBookingTypeRequestDTO , cancelToken?: CancelToken | undefined): Promise<EmptyControllerActionResult> {
        let url_ = this.baseUrl + "/booking-object/manage-booking-type";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processManageBookingType(_response);
        });
    }

    protected processManageBookingType(response: AxiosResponse): Promise<EmptyControllerActionResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EmptyControllerActionResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyControllerActionResult>(null as any);
    }

    capacity(requestDTO: ReadBookingObjectCapacityRequestDTO , cancelToken?: CancelToken | undefined): Promise<BookingObjectCapacityResponseDTO> {
        let url_ = this.baseUrl + "/booking-object/capacity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCapacity(_response);
        });
    }

    protected processCapacity(response: AxiosResponse): Promise<BookingObjectCapacityResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BookingObjectCapacityResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingObjectCapacityResponseDTO>(null as any);
    }

    summaryForOccupancySchedule(requestDTO: ReadBookingObjectSummaryForOccupancyScheduleRequestDTO , cancelToken?: CancelToken | undefined): Promise<BookingObjectSummaryForOccupancyScheduleVDTO> {
        let url_ = this.baseUrl + "/booking-object/summary-for-occupancy-schedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSummaryForOccupancySchedule(_response);
        });
    }

    protected processSummaryForOccupancySchedule(response: AxiosResponse): Promise<BookingObjectSummaryForOccupancyScheduleVDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BookingObjectSummaryForOccupancyScheduleVDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingObjectSummaryForOccupancyScheduleVDTO>(null as any);
    }

    summariesForOccupancySchedule(requestDTO: ReadBookingObjectSummariesForOccupancyScheduleRequestDTO , cancelToken?: CancelToken | undefined): Promise<BookingObjectSummaryForOccupancyScheduleVDTO[]> {
        let url_ = this.baseUrl + "/booking-object/summaries-for-occupancy-schedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSummariesForOccupancySchedule(_response);
        });
    }

    protected processSummariesForOccupancySchedule(response: AxiosResponse): Promise<BookingObjectSummaryForOccupancyScheduleVDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BookingObjectSummaryForOccupancyScheduleVDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingObjectSummaryForOccupancyScheduleVDTO[]>(null as any);
    }

    summaryForPricePolicyManagement(requestDTO: ReadBookingObjectSummaryForPricePolicyManagementRequestDTO , cancelToken?: CancelToken | undefined): Promise<BookingObjectSummaryForPricePolicyManagementVDTO> {
        let url_ = this.baseUrl + "/booking-object/summary-for-price-policy-management";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSummaryForPricePolicyManagement(_response);
        });
    }

    protected processSummaryForPricePolicyManagement(response: AxiosResponse): Promise<BookingObjectSummaryForPricePolicyManagementVDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BookingObjectSummaryForPricePolicyManagementVDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingObjectSummaryForPricePolicyManagementVDTO>(null as any);
    }

    get(id?: string | undefined , cancelToken?: CancelToken | undefined): Promise<BookingObjectDTO> {
        let url_ = this.baseUrl + "/booking-object/get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<BookingObjectDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BookingObjectDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingObjectDTO>(null as any);
    }

    mine(  cancelToken?: CancelToken | undefined): Promise<BookingObjectSummaryVDTO[]> {
        let url_ = this.baseUrl + "/booking-object/mine";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMine(_response);
        });
    }

    protected processMine(response: AxiosResponse): Promise<BookingObjectSummaryVDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BookingObjectSummaryVDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingObjectSummaryVDTO[]>(null as any);
    }

    summariesForUser(requestDTO: ReadBookingObjectSummariesForUserRequestDTO , cancelToken?: CancelToken | undefined): Promise<BookingObjectSummaryVDTO[]> {
        let url_ = this.baseUrl + "/booking-object/summaries-for-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSummariesForUser(_response);
        });
    }

    protected processSummariesForUser(response: AxiosResponse): Promise<BookingObjectSummaryVDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BookingObjectSummaryVDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingObjectSummaryVDTO[]>(null as any);
    }

    summariesForFavorites(options: ReadBookingObjectSummaryForFavoritesRequestDTO , cancelToken?: CancelToken | undefined): Promise<BookingObjectSummaryVDTO[]> {
        let url_ = this.baseUrl + "/booking-object/summaries-for-favorites";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSummariesForFavorites(_response);
        });
    }

    protected processSummariesForFavorites(response: AxiosResponse): Promise<BookingObjectSummaryVDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BookingObjectSummaryVDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingObjectSummaryVDTO[]>(null as any);
    }

    byUser(requestDTO: ReadBookingObjectsForUserRequestDTO , cancelToken?: CancelToken | undefined): Promise<BookingObjectsForUserVDTO> {
        let url_ = this.baseUrl + "/booking-object/by-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processByUser(_response);
        });
    }

    protected processByUser(response: AxiosResponse): Promise<BookingObjectsForUserVDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BookingObjectsForUserVDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingObjectsForUserVDTO>(null as any);
    }

    structure(requestDTO: ReadBookingObjectsStructureForUserRequestDTO , cancelToken?: CancelToken | undefined): Promise<BookingObjectStructureVDTO[]> {
        let url_ = this.baseUrl + "/booking-object/structure";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStructure(_response);
        });
    }

    protected processStructure(response: AxiosResponse): Promise<BookingObjectStructureVDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BookingObjectStructureVDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingObjectStructureVDTO[]>(null as any);
    }
}

export interface IBookingObjectPricePoliciesClient {
    create(requestDTO: CreateBookingObjectPricePolicyRequestDTO): Promise<ControllerActionResultOfGuid>;
    update(requestDTO: UpdateBookingObjectPricePolicyRequestDTO): Promise<EmptyControllerActionResult>;
    delete(requestDTO: DeleteBookingObjectPricePolicyRequestDTO): Promise<EmptyControllerActionResult>;
    readForBookingObject(requestDTO: ReadPricePoliciesForBookingObjectRequestDTO): Promise<BookingObjectPricePolicyVDTO[]>;
    readByFilter(requestDTO: ReadBookingObjectPricePoliciesByFilterRequestDTO): Promise<BookingObjectPricePolicyVDTO[]>;
    minimumPrices(requestDTO: ReadMinimumPricesRequestDTO): Promise<BookingObjectMinimumPriceVDTO[]>;
}

export class BookingObjectPricePoliciesClient implements IBookingObjectPricePoliciesClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";

    }

    create(requestDTO: CreateBookingObjectPricePolicyRequestDTO , cancelToken?: CancelToken | undefined): Promise<ControllerActionResultOfGuid> {
        let url_ = this.baseUrl + "/booking-object/price-policy/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ControllerActionResultOfGuid> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ControllerActionResultOfGuid>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ControllerActionResultOfGuid>(null as any);
    }

    update(requestDTO: UpdateBookingObjectPricePolicyRequestDTO , cancelToken?: CancelToken | undefined): Promise<EmptyControllerActionResult> {
        let url_ = this.baseUrl + "/booking-object/price-policy/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<EmptyControllerActionResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EmptyControllerActionResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyControllerActionResult>(null as any);
    }

    delete(requestDTO: DeleteBookingObjectPricePolicyRequestDTO , cancelToken?: CancelToken | undefined): Promise<EmptyControllerActionResult> {
        let url_ = this.baseUrl + "/booking-object/price-policy/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<EmptyControllerActionResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EmptyControllerActionResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyControllerActionResult>(null as any);
    }

    readForBookingObject(requestDTO: ReadPricePoliciesForBookingObjectRequestDTO , cancelToken?: CancelToken | undefined): Promise<BookingObjectPricePolicyVDTO[]> {
        let url_ = this.baseUrl + "/booking-object/price-policy/read-for-booking-object";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadForBookingObject(_response);
        });
    }

    protected processReadForBookingObject(response: AxiosResponse): Promise<BookingObjectPricePolicyVDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BookingObjectPricePolicyVDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingObjectPricePolicyVDTO[]>(null as any);
    }

    readByFilter(requestDTO: ReadBookingObjectPricePoliciesByFilterRequestDTO , cancelToken?: CancelToken | undefined): Promise<BookingObjectPricePolicyVDTO[]> {
        let url_ = this.baseUrl + "/booking-object/price-policy/read-by-filter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadByFilter(_response);
        });
    }

    protected processReadByFilter(response: AxiosResponse): Promise<BookingObjectPricePolicyVDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BookingObjectPricePolicyVDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingObjectPricePolicyVDTO[]>(null as any);
    }

    minimumPrices(requestDTO: ReadMinimumPricesRequestDTO , cancelToken?: CancelToken | undefined): Promise<BookingObjectMinimumPriceVDTO[]> {
        let url_ = this.baseUrl + "/booking-object/price-policy/minimum-prices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMinimumPrices(_response);
        });
    }

    protected processMinimumPrices(response: AxiosResponse): Promise<BookingObjectMinimumPriceVDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BookingObjectMinimumPriceVDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingObjectMinimumPriceVDTO[]>(null as any);
    }
}

export interface IBookingClient {
    create(requestDTO: CreateBookingRequestDTO): Promise<ControllerActionResultOfBookingCreatingResultResponseDTO>;
    prevalidate(requestDTO: PrevalidateBookingRequestDTO): Promise<ControllerActionResultOfBoolean>;
    confirm(requestDTO: ConfirmBookingRequestDTO): Promise<EmptyControllerActionResult>;
    cancel(requestDTO: CancelBookingRequestDTO): Promise<EmptyControllerActionResult>;
    reject(requestDTO: RejectBookingRequestDTO): Promise<EmptyControllerActionResult>;
    isFreeCancellationAllowed(requestDTO: IsFreeCancellationAllowedRequestDTO): Promise<IsFreeCancellationAllowedResponseDTO>;
    readForConsumer(): Promise<BookingVDTO[]>;
    readForProvider(): Promise<BookingVDTO[]>;
    readById(requestDTO: ReadBookingByIdRequestDTO): Promise<BookingVDTO>;
    readForBookingObject(requestDTO: ReadBookingsForBookingObjectRequestDTO): Promise<BookingVDTO[]>;
    readForBookingObjects(requestDTO: ReadBookingsForBookingObjectsRequestDTO): Promise<BookingVDTO[]>;
    bookingsCountToConfirm(): Promise<number>;
    readByFilter(requestDTO: ReadBookingsByFilterPagedRequestDTO): Promise<PagedReadingResultOfBookingVDTO>;
}

export class BookingClient implements IBookingClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";

    }

    create(requestDTO: CreateBookingRequestDTO , cancelToken?: CancelToken | undefined): Promise<ControllerActionResultOfBookingCreatingResultResponseDTO> {
        let url_ = this.baseUrl + "/booking/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ControllerActionResultOfBookingCreatingResultResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ControllerActionResultOfBookingCreatingResultResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ControllerActionResultOfBookingCreatingResultResponseDTO>(null as any);
    }

    prevalidate(requestDTO: PrevalidateBookingRequestDTO , cancelToken?: CancelToken | undefined): Promise<ControllerActionResultOfBoolean> {
        let url_ = this.baseUrl + "/booking/prevalidate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPrevalidate(_response);
        });
    }

    protected processPrevalidate(response: AxiosResponse): Promise<ControllerActionResultOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ControllerActionResultOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ControllerActionResultOfBoolean>(null as any);
    }

    confirm(requestDTO: ConfirmBookingRequestDTO , cancelToken?: CancelToken | undefined): Promise<EmptyControllerActionResult> {
        let url_ = this.baseUrl + "/booking/confirm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConfirm(_response);
        });
    }

    protected processConfirm(response: AxiosResponse): Promise<EmptyControllerActionResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EmptyControllerActionResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyControllerActionResult>(null as any);
    }

    cancel(requestDTO: CancelBookingRequestDTO , cancelToken?: CancelToken | undefined): Promise<EmptyControllerActionResult> {
        let url_ = this.baseUrl + "/booking/cancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancel(_response);
        });
    }

    protected processCancel(response: AxiosResponse): Promise<EmptyControllerActionResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EmptyControllerActionResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyControllerActionResult>(null as any);
    }

    reject(requestDTO: RejectBookingRequestDTO , cancelToken?: CancelToken | undefined): Promise<EmptyControllerActionResult> {
        let url_ = this.baseUrl + "/booking/reject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReject(_response);
        });
    }

    protected processReject(response: AxiosResponse): Promise<EmptyControllerActionResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EmptyControllerActionResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyControllerActionResult>(null as any);
    }

    isFreeCancellationAllowed(requestDTO: IsFreeCancellationAllowedRequestDTO , cancelToken?: CancelToken | undefined): Promise<IsFreeCancellationAllowedResponseDTO> {
        let url_ = this.baseUrl + "/booking/is-free-cancellation-allowed";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsFreeCancellationAllowed(_response);
        });
    }

    protected processIsFreeCancellationAllowed(response: AxiosResponse): Promise<IsFreeCancellationAllowedResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<IsFreeCancellationAllowedResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IsFreeCancellationAllowedResponseDTO>(null as any);
    }

    readForConsumer(  cancelToken?: CancelToken | undefined): Promise<BookingVDTO[]> {
        let url_ = this.baseUrl + "/booking/read-for-consumer";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadForConsumer(_response);
        });
    }

    protected processReadForConsumer(response: AxiosResponse): Promise<BookingVDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BookingVDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingVDTO[]>(null as any);
    }

    readForProvider(  cancelToken?: CancelToken | undefined): Promise<BookingVDTO[]> {
        let url_ = this.baseUrl + "/booking/read-for-provider";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadForProvider(_response);
        });
    }

    protected processReadForProvider(response: AxiosResponse): Promise<BookingVDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BookingVDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingVDTO[]>(null as any);
    }

    readById(requestDTO: ReadBookingByIdRequestDTO , cancelToken?: CancelToken | undefined): Promise<BookingVDTO> {
        let url_ = this.baseUrl + "/booking/read-by-id";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadById(_response);
        });
    }

    protected processReadById(response: AxiosResponse): Promise<BookingVDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BookingVDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingVDTO>(null as any);
    }

    readForBookingObject(requestDTO: ReadBookingsForBookingObjectRequestDTO , cancelToken?: CancelToken | undefined): Promise<BookingVDTO[]> {
        let url_ = this.baseUrl + "/booking/read-for-booking-object";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadForBookingObject(_response);
        });
    }

    protected processReadForBookingObject(response: AxiosResponse): Promise<BookingVDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BookingVDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingVDTO[]>(null as any);
    }

    readForBookingObjects(requestDTO: ReadBookingsForBookingObjectsRequestDTO , cancelToken?: CancelToken | undefined): Promise<BookingVDTO[]> {
        let url_ = this.baseUrl + "/booking/read-for-booking-objects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadForBookingObjects(_response);
        });
    }

    protected processReadForBookingObjects(response: AxiosResponse): Promise<BookingVDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BookingVDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingVDTO[]>(null as any);
    }

    bookingsCountToConfirm(  cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/booking/bookings-count-to-confirm";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBookingsCountToConfirm(_response);
        });
    }

    protected processBookingsCountToConfirm(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    readByFilter(requestDTO: ReadBookingsByFilterPagedRequestDTO , cancelToken?: CancelToken | undefined): Promise<PagedReadingResultOfBookingVDTO> {
        let url_ = this.baseUrl + "/booking/read-by-filter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadByFilter(_response);
        });
    }

    protected processReadByFilter(response: AxiosResponse): Promise<PagedReadingResultOfBookingVDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PagedReadingResultOfBookingVDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedReadingResultOfBookingVDTO>(null as any);
    }
}

export interface IBookingCostBuildingClient {
    prebuild(requestDTO: PrebuildBookingPricesRequestDTO): Promise<BookingCostBuildingResultVDTO[]>;
    build(requestDTO: BuildBookingCostRequestDTO): Promise<BookingCostBuildingResultVDTO>;
}

export class BookingCostBuildingClient implements IBookingCostBuildingClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";

    }

    prebuild(requestDTO: PrebuildBookingPricesRequestDTO , cancelToken?: CancelToken | undefined): Promise<BookingCostBuildingResultVDTO[]> {
        let url_ = this.baseUrl + "/booking/price-building/prebuild";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPrebuild(_response);
        });
    }

    protected processPrebuild(response: AxiosResponse): Promise<BookingCostBuildingResultVDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BookingCostBuildingResultVDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingCostBuildingResultVDTO[]>(null as any);
    }

    build(requestDTO: BuildBookingCostRequestDTO , cancelToken?: CancelToken | undefined): Promise<BookingCostBuildingResultVDTO> {
        let url_ = this.baseUrl + "/booking/price-building/build";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBuild(_response);
        });
    }

    protected processBuild(response: AxiosResponse): Promise<BookingCostBuildingResultVDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BookingCostBuildingResultVDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingCostBuildingResultVDTO>(null as any);
    }
}

export interface IBusinessModelClient {
    booking(): Promise<BookingBusinessModelParametersVDTO>;
}

export class BusinessModelClient implements IBusinessModelClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";

    }

    booking(  cancelToken?: CancelToken | undefined): Promise<BookingBusinessModelParametersVDTO> {
        let url_ = this.baseUrl + "/business-model-parameters/booking";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBooking(_response);
        });
    }

    protected processBooking(response: AxiosResponse): Promise<BookingBusinessModelParametersVDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BookingBusinessModelParametersVDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingBusinessModelParametersVDTO>(null as any);
    }
}

export interface IConversationClient {
    sendMessage(requestDTO: SendMessageRequestDTO): Promise<ControllerActionResultOfConversationMessageVDTO>;
    markMessagesAsRead(requestDTO: MarkConversationMessagesAsReadForUserRequestDTO): Promise<EmptyControllerActionResult>;
    summariesForUser(requestDTO: ReadConversationSummariesForUserRequestDTO): Promise<ConversationSummaryForUserVDTO[]>;
    readConversationMessagesPartitioned(requestDTO: ReadConversationMessagesPartitionedRequestDTO): Promise<ConversationMessageVDTO[]>;
    unreadConversationMessagesCount(requestDTO: ReadUnreadMessagesCountRequestDTO): Promise<number>;
    readBookingRelatedConversationId(requestDTO: ReadBookingRelatedConversationIdRequestDTO): Promise<string>;
}

export class ConversationClient implements IConversationClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";

    }

    sendMessage(requestDTO: SendMessageRequestDTO , cancelToken?: CancelToken | undefined): Promise<ControllerActionResultOfConversationMessageVDTO> {
        let url_ = this.baseUrl + "/conversation/send-message";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendMessage(_response);
        });
    }

    protected processSendMessage(response: AxiosResponse): Promise<ControllerActionResultOfConversationMessageVDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ControllerActionResultOfConversationMessageVDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ControllerActionResultOfConversationMessageVDTO>(null as any);
    }

    markMessagesAsRead(requestDTO: MarkConversationMessagesAsReadForUserRequestDTO , cancelToken?: CancelToken | undefined): Promise<EmptyControllerActionResult> {
        let url_ = this.baseUrl + "/conversation/mark-messages-as-read";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMarkMessagesAsRead(_response);
        });
    }

    protected processMarkMessagesAsRead(response: AxiosResponse): Promise<EmptyControllerActionResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EmptyControllerActionResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyControllerActionResult>(null as any);
    }

    summariesForUser(requestDTO: ReadConversationSummariesForUserRequestDTO , cancelToken?: CancelToken | undefined): Promise<ConversationSummaryForUserVDTO[]> {
        let url_ = this.baseUrl + "/conversation/summaries-for-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSummariesForUser(_response);
        });
    }

    protected processSummariesForUser(response: AxiosResponse): Promise<ConversationSummaryForUserVDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ConversationSummaryForUserVDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConversationSummaryForUserVDTO[]>(null as any);
    }

    readConversationMessagesPartitioned(requestDTO: ReadConversationMessagesPartitionedRequestDTO , cancelToken?: CancelToken | undefined): Promise<ConversationMessageVDTO[]> {
        let url_ = this.baseUrl + "/conversation/read-conversation-messages-partitioned";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadConversationMessagesPartitioned(_response);
        });
    }

    protected processReadConversationMessagesPartitioned(response: AxiosResponse): Promise<ConversationMessageVDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ConversationMessageVDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConversationMessageVDTO[]>(null as any);
    }

    unreadConversationMessagesCount(requestDTO: ReadUnreadMessagesCountRequestDTO , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/conversation/unread-conversation-messages-count";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnreadConversationMessagesCount(_response);
        });
    }

    protected processUnreadConversationMessagesCount(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    readBookingRelatedConversationId(requestDTO: ReadBookingRelatedConversationIdRequestDTO , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/conversation/read-booking-related-conversation-id";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadBookingRelatedConversationId(_response);
        });
    }

    protected processReadBookingRelatedConversationId(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface IDebugClient {
    triggerJob(job: string): Promise<FileResponse>;
}

export class DebugClient implements IDebugClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";

    }

    triggerJob(job: string , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/debug/trigger-job/{job}";
        if (job === undefined || job === null)
            throw new Error("The parameter 'job' must be defined.");
        url_ = url_.replace("{job}", encodeURIComponent("" + job));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTriggerJob(_response);
        });
    }

    protected processTriggerJob(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IExchangeRatesClient {
    readActual(): Promise<ExchangeRateVDTO[]>;
}

export class ExchangeRatesClient implements IExchangeRatesClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";

    }

    readActual(  cancelToken?: CancelToken | undefined): Promise<ExchangeRateVDTO[]> {
        let url_ = this.baseUrl + "/exchange-rates/read-actual";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadActual(_response);
        });
    }

    protected processReadActual(response: AxiosResponse): Promise<ExchangeRateVDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ExchangeRateVDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExchangeRateVDTO[]>(null as any);
    }
}

export interface GeoLocationResultDTO {
    CountryId: number;
}

export interface IGeoLocationClient {
    resolveLocation(): Promise<GeoLocationResultDTO>;
}

export class GeoLocationClient implements IGeoLocationClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";

    }

    resolveLocation(  cancelToken?: CancelToken | undefined): Promise<GeoLocationResultDTO> {
        let url_ = this.baseUrl + "/geo-location";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResolveLocation(_response);
        });
    }

    protected processResolveLocation(response: AxiosResponse): Promise<GeoLocationResultDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GeoLocationResultDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GeoLocationResultDTO>(null as any);
    }
}

export interface IFavoritesClient {
    create(requestDTO: CreateFavoriteRequestDTO): Promise<EmptyControllerActionResult>;
    remove(requestDTO: RemoveFavoriteRequestDTO): Promise<EmptyControllerActionResult>;
    readPaged(requestDTO: ReadUserFavoritesPagedRequestDTO): Promise<PagedReadingResultOfUserFavoriteVDTO>;
}

export class FavoritesClient implements IFavoritesClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";

    }

    create(requestDTO: CreateFavoriteRequestDTO , cancelToken?: CancelToken | undefined): Promise<EmptyControllerActionResult> {
        let url_ = this.baseUrl + "/favorites/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<EmptyControllerActionResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EmptyControllerActionResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyControllerActionResult>(null as any);
    }

    remove(requestDTO: RemoveFavoriteRequestDTO , cancelToken?: CancelToken | undefined): Promise<EmptyControllerActionResult> {
        let url_ = this.baseUrl + "/favorites/remove";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: AxiosResponse): Promise<EmptyControllerActionResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EmptyControllerActionResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyControllerActionResult>(null as any);
    }

    readPaged(requestDTO: ReadUserFavoritesPagedRequestDTO , cancelToken?: CancelToken | undefined): Promise<PagedReadingResultOfUserFavoriteVDTO> {
        let url_ = this.baseUrl + "/favorites/read-paged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadPaged(_response);
        });
    }

    protected processReadPaged(response: AxiosResponse): Promise<PagedReadingResultOfUserFavoriteVDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PagedReadingResultOfUserFavoriteVDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedReadingResultOfUserFavoriteVDTO>(null as any);
    }
}

export interface IFileClient {
    upload(files?: FileParameter[] | null | undefined): Promise<FilesUploadingResult>;
    uploadForCms(file?: FileParameter | null | undefined): Promise<FileUploadingResultVDTO>;
    uploadUserAvatar(avatarFile?: FileParameter | null | undefined): Promise<UserAvatarUploadingResultVDTO>;
    uploadBookingObjectPhotos(photos?: FileParameter[] | null | undefined): Promise<BookingObjectPhotosUploadingResultVDTO>;
}

export class FileClient implements IFileClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";

    }

    upload(files?: FileParameter[] | null | undefined , cancelToken?: CancelToken | undefined): Promise<FilesUploadingResult> {
        let url_ = this.baseUrl + "/file/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: AxiosResponse): Promise<FilesUploadingResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FilesUploadingResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilesUploadingResult>(null as any);
    }

    uploadForCms(file?: FileParameter | null | undefined , cancelToken?: CancelToken | undefined): Promise<FileUploadingResultVDTO> {
        let url_ = this.baseUrl + "/file/upload-for-cms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadForCms(_response);
        });
    }

    protected processUploadForCms(response: AxiosResponse): Promise<FileUploadingResultVDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FileUploadingResultVDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileUploadingResultVDTO>(null as any);
    }

    uploadUserAvatar(avatarFile?: FileParameter | null | undefined , cancelToken?: CancelToken | undefined): Promise<UserAvatarUploadingResultVDTO> {
        let url_ = this.baseUrl + "/file/upload-user-avatar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (avatarFile !== null && avatarFile !== undefined)
            content_.append("avatarFile", avatarFile.data, avatarFile.fileName ? avatarFile.fileName : "avatarFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadUserAvatar(_response);
        });
    }

    protected processUploadUserAvatar(response: AxiosResponse): Promise<UserAvatarUploadingResultVDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserAvatarUploadingResultVDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserAvatarUploadingResultVDTO>(null as any);
    }

    uploadBookingObjectPhotos(photos?: FileParameter[] | null | undefined , cancelToken?: CancelToken | undefined): Promise<BookingObjectPhotosUploadingResultVDTO> {
        let url_ = this.baseUrl + "/file/upload-booking-object-photos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (photos !== null && photos !== undefined)
            photos.forEach(item_ => content_.append("photos", item_.data, item_.fileName ? item_.fileName : "photos") );

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadBookingObjectPhotos(_response);
        });
    }

    protected processUploadBookingObjectPhotos(response: AxiosResponse): Promise<BookingObjectPhotosUploadingResultVDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BookingObjectPhotosUploadingResultVDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingObjectPhotosUploadingResultVDTO>(null as any);
    }
}

export interface IHealthCheckClient {
    check(): Promise<FileResponse>;
    testemail(): Promise<FileResponse>;
}

export class HealthCheckClient implements IHealthCheckClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";

    }

    check(  cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/health/check";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheck(_response);
        });
    }

    protected processCheck(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    testemail(  cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/health/testemail";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestemail(_response);
        });
    }

    protected processTestemail(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IMetadataClient {
    countries(): Promise<CountryVDTO[]>;
    currencies(): Promise<CurrencyVDTO[]>;
    timezones(): Promise<TimezoneReadDTO[]>;
    languages(): Promise<LanguageReadDTO[]>;
}

export class MetadataClient implements IMetadataClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";

    }

    countries(  cancelToken?: CancelToken | undefined): Promise<CountryVDTO[]> {
        let url_ = this.baseUrl + "/metadata/countries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCountries(_response);
        });
    }

    protected processCountries(response: AxiosResponse): Promise<CountryVDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CountryVDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CountryVDTO[]>(null as any);
    }

    currencies(  cancelToken?: CancelToken | undefined): Promise<CurrencyVDTO[]> {
        let url_ = this.baseUrl + "/metadata/currencies";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCurrencies(_response);
        });
    }

    protected processCurrencies(response: AxiosResponse): Promise<CurrencyVDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CurrencyVDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CurrencyVDTO[]>(null as any);
    }

    timezones(  cancelToken?: CancelToken | undefined): Promise<TimezoneReadDTO[]> {
        let url_ = this.baseUrl + "/metadata/timezones";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTimezones(_response);
        });
    }

    protected processTimezones(response: AxiosResponse): Promise<TimezoneReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TimezoneReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TimezoneReadDTO[]>(null as any);
    }

    languages(  cancelToken?: CancelToken | undefined): Promise<LanguageReadDTO[]> {
        let url_ = this.baseUrl + "/metadata/languages";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLanguages(_response);
        });
    }

    protected processLanguages(response: AxiosResponse): Promise<LanguageReadDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<LanguageReadDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LanguageReadDTO[]>(null as any);
    }
}

export interface IOccupancyScheduleClient {
    synchronize(requestDTO: SynchronizeOccupancyScheduleRequestDTO): Promise<EmptyControllerActionResult>;
    isSynchronizationWorking(bookingObjectId: string): Promise<boolean>;
}

export class OccupancyScheduleClient implements IOccupancyScheduleClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";

    }

    synchronize(requestDTO: SynchronizeOccupancyScheduleRequestDTO , cancelToken?: CancelToken | undefined): Promise<EmptyControllerActionResult> {
        let url_ = this.baseUrl + "/occupancy-schedule/synchronize";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSynchronize(_response);
        });
    }

    protected processSynchronize(response: AxiosResponse): Promise<EmptyControllerActionResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EmptyControllerActionResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyControllerActionResult>(null as any);
    }

    isSynchronizationWorking(bookingObjectId: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/occupancy-schedule/is-synchronization-working?";
        if (bookingObjectId === undefined || bookingObjectId === null)
            throw new Error("The parameter 'bookingObjectId' must be defined and cannot be null.");
        else
            url_ += "bookingObjectId=" + encodeURIComponent("" + bookingObjectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsSynchronizationWorking(_response);
        });
    }

    protected processIsSynchronizationWorking(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IRatingClient {
    createFromClient(requestDTO: CreateBookingObjectClientReviewRequestDTO): Promise<EmptyControllerActionResult>;
    score(request: CalculateBookingObjectScoreRequestDTO): Promise<CalculateBookingObjectScoreResponseDTO>;
    last(requestDTO: ReadLastReviewsRequestDTO): Promise<BookingObjectReviewPublicSummaryVDTO[]>;
    read(request: ReadBookingObjectReviewsRequestDTO): Promise<PagedReadingResultOfBookingObjectReviewPublicSummaryVDTO>;
}

export class RatingClient implements IRatingClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";

    }

    createFromClient(requestDTO: CreateBookingObjectClientReviewRequestDTO , cancelToken?: CancelToken | undefined): Promise<EmptyControllerActionResult> {
        let url_ = this.baseUrl + "/rating/create-from-client";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateFromClient(_response);
        });
    }

    protected processCreateFromClient(response: AxiosResponse): Promise<EmptyControllerActionResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EmptyControllerActionResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyControllerActionResult>(null as any);
    }

    score(request: CalculateBookingObjectScoreRequestDTO , cancelToken?: CancelToken | undefined): Promise<CalculateBookingObjectScoreResponseDTO> {
        let url_ = this.baseUrl + "/rating/score";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processScore(_response);
        });
    }

    protected processScore(response: AxiosResponse): Promise<CalculateBookingObjectScoreResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CalculateBookingObjectScoreResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CalculateBookingObjectScoreResponseDTO>(null as any);
    }

    last(requestDTO: ReadLastReviewsRequestDTO , cancelToken?: CancelToken | undefined): Promise<BookingObjectReviewPublicSummaryVDTO[]> {
        let url_ = this.baseUrl + "/rating/last";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLast(_response);
        });
    }

    protected processLast(response: AxiosResponse): Promise<BookingObjectReviewPublicSummaryVDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BookingObjectReviewPublicSummaryVDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingObjectReviewPublicSummaryVDTO[]>(null as any);
    }

    read(request: ReadBookingObjectReviewsRequestDTO , cancelToken?: CancelToken | undefined): Promise<PagedReadingResultOfBookingObjectReviewPublicSummaryVDTO> {
        let url_ = this.baseUrl + "/rating/read";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRead(_response);
        });
    }

    protected processRead(response: AxiosResponse): Promise<PagedReadingResultOfBookingObjectReviewPublicSummaryVDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PagedReadingResultOfBookingObjectReviewPublicSummaryVDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedReadingResultOfBookingObjectReviewPublicSummaryVDTO>(null as any);
    }
}

export interface IShortLinksClient {
    decode(key: string): Promise<string>;
}

export class ShortLinksClient implements IShortLinksClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";

    }

    decode(key: string , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/short-links/decode/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDecode(_response);
        });
    }

    protected processDecode(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface ISitemapClient {
    build(): Promise<FileResponse>;
}

export class SitemapClient implements ISitemapClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";

    }

    build(  cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/sitemap/build";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBuild(_response);
        });
    }

    protected processBuild(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface ISupportRequestClient {
    send(requestDTO: SendSupportRequestDTO): Promise<FileResponse>;
}

export class SupportRequestClient implements ISupportRequestClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";

    }

    send(requestDTO: SendSupportRequestDTO , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/support-request/send";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSend(_response);
        });
    }

    protected processSend(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IUserClient {
    summariesForMailing(): Promise<UserSummaryForMailingVDTO[]>;
}

export class UserClient implements IUserClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";

    }

    summariesForMailing(  cancelToken?: CancelToken | undefined): Promise<UserSummaryForMailingVDTO[]> {
        let url_ = this.baseUrl + "/user/summaries-for-mailing";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSummariesForMailing(_response);
        });
    }

    protected processSummariesForMailing(response: AxiosResponse): Promise<UserSummaryForMailingVDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserSummaryForMailingVDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserSummaryForMailingVDTO[]>(null as any);
    }
}

export interface IAccountClient {
    changePassword(requestDTO: ChangePasswordRequestDTO): Promise<EmptyControllerActionResult>;
    sendRestorePasswordApplication(requestDTO: SendRestorePasswordApplicationDTO): Promise<EmptyControllerActionResult>;
    resetPassword(requestDTO: ResetPasswordRequestDTO): Promise<EmptyControllerActionResult>;
    updateInformation(requestDTO: UpdateUserInformationRequestDTO): Promise<EmptyControllerActionResult>;
    token(operationOptions: LoginRequestDTO): Promise<ControllerActionResultOfLoginResponseDTO>;
    logout(): Promise<FileResponse>;
    refreshtoken(): Promise<FileResponse>;
    register(registerModel: RegisterRequestDTO): Promise<ControllerActionResultOfRegisterResponseDTO>;
    getCurrentUserData(): Promise<ControllerActionResultOfCurrentUserDataResponseDTO>;
    publicData(request: ReadUserPublicDataRequestDTO): Promise<UserPublicDataResponseDTO>;
}

export class AccountClient implements IAccountClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";

    }

    changePassword(requestDTO: ChangePasswordRequestDTO , cancelToken?: CancelToken | undefined): Promise<EmptyControllerActionResult> {
        let url_ = this.baseUrl + "/identity/account/change-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: AxiosResponse): Promise<EmptyControllerActionResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EmptyControllerActionResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyControllerActionResult>(null as any);
    }

    sendRestorePasswordApplication(requestDTO: SendRestorePasswordApplicationDTO , cancelToken?: CancelToken | undefined): Promise<EmptyControllerActionResult> {
        let url_ = this.baseUrl + "/identity/account/send-restore-password-application";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendRestorePasswordApplication(_response);
        });
    }

    protected processSendRestorePasswordApplication(response: AxiosResponse): Promise<EmptyControllerActionResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EmptyControllerActionResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyControllerActionResult>(null as any);
    }

    resetPassword(requestDTO: ResetPasswordRequestDTO , cancelToken?: CancelToken | undefined): Promise<EmptyControllerActionResult> {
        let url_ = this.baseUrl + "/identity/account/reset-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: AxiosResponse): Promise<EmptyControllerActionResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EmptyControllerActionResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyControllerActionResult>(null as any);
    }

    updateInformation(requestDTO: UpdateUserInformationRequestDTO , cancelToken?: CancelToken | undefined): Promise<EmptyControllerActionResult> {
        let url_ = this.baseUrl + "/identity/account/update-information";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateInformation(_response);
        });
    }

    protected processUpdateInformation(response: AxiosResponse): Promise<EmptyControllerActionResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EmptyControllerActionResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyControllerActionResult>(null as any);
    }

    token(operationOptions: LoginRequestDTO , cancelToken?: CancelToken | undefined): Promise<ControllerActionResultOfLoginResponseDTO> {
        let url_ = this.baseUrl + "/identity/account/token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operationOptions);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processToken(_response);
        });
    }

    protected processToken(response: AxiosResponse): Promise<ControllerActionResultOfLoginResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ControllerActionResultOfLoginResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ControllerActionResultOfLoginResponseDTO>(null as any);
    }

    logout(  cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/identity/account/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    refreshtoken(  cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/identity/account/refreshtoken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshtoken(_response);
        });
    }

    protected processRefreshtoken(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    register(registerModel: RegisterRequestDTO , cancelToken?: CancelToken | undefined): Promise<ControllerActionResultOfRegisterResponseDTO> {
        let url_ = this.baseUrl + "/identity/account/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(registerModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegister(_response);
        });
    }

    protected processRegister(response: AxiosResponse): Promise<ControllerActionResultOfRegisterResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ControllerActionResultOfRegisterResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ControllerActionResultOfRegisterResponseDTO>(null as any);
    }

    getCurrentUserData(  cancelToken?: CancelToken | undefined): Promise<ControllerActionResultOfCurrentUserDataResponseDTO> {
        let url_ = this.baseUrl + "/identity/account/get-current-user-data";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentUserData(_response);
        });
    }

    protected processGetCurrentUserData(response: AxiosResponse): Promise<ControllerActionResultOfCurrentUserDataResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ControllerActionResultOfCurrentUserDataResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ControllerActionResultOfCurrentUserDataResponseDTO>(null as any);
    }

    publicData(request: ReadUserPublicDataRequestDTO , cancelToken?: CancelToken | undefined): Promise<UserPublicDataResponseDTO> {
        let url_ = this.baseUrl + "/identity/account/public-data";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPublicData(_response);
        });
    }

    protected processPublicData(response: AxiosResponse): Promise<UserPublicDataResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserPublicDataResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserPublicDataResponseDTO>(null as any);
    }
}

export interface IUserSummaryClient {
    forConversation(request: ReadUserSummariesForConversationRequestDTO): Promise<UserSummaryForConversationVDTO[]>;
}

export class UserSummaryClient implements IUserSummaryClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";

    }

    forConversation(request: ReadUserSummariesForConversationRequestDTO , cancelToken?: CancelToken | undefined): Promise<UserSummaryForConversationVDTO[]> {
        let url_ = this.baseUrl + "/identity/user-summary/for-conversation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processForConversation(_response);
        });
    }

    protected processForConversation(response: AxiosResponse): Promise<UserSummaryForConversationVDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserSummaryForConversationVDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserSummaryForConversationVDTO[]>(null as any);
    }
}

export interface IBookingSummaryClient {
    forConversation(requestDTO: ReadBookingSummariesForConversationRequestDTO): Promise<BookingSummaryForConversationVDTO[]>;
}

export class BookingSummaryClient implements IBookingSummaryClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";

    }

    forConversation(requestDTO: ReadBookingSummariesForConversationRequestDTO , cancelToken?: CancelToken | undefined): Promise<BookingSummaryForConversationVDTO[]> {
        let url_ = this.baseUrl + "/booking/summary/for-conversation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processForConversation(_response);
        });
    }

    protected processForConversation(response: AxiosResponse): Promise<BookingSummaryForConversationVDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BookingSummaryForConversationVDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingSummaryForConversationVDTO[]>(null as any);
    }
}

export interface IBookingObjectFilteringClient {
    apply(request: ReadBookingObjectsByFilterPagedRequestDTO): Promise<PagedReadingResultOfBookingObjectSummaryVDTO>;
}

export class BookingObjectFilteringClient implements IBookingObjectFilteringClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";

    }

    apply(request: ReadBookingObjectsByFilterPagedRequestDTO , cancelToken?: CancelToken | undefined): Promise<PagedReadingResultOfBookingObjectSummaryVDTO> {
        let url_ = this.baseUrl + "/booking-object-filtering/apply";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApply(_response);
        });
    }

    protected processApply(response: AxiosResponse): Promise<PagedReadingResultOfBookingObjectSummaryVDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PagedReadingResultOfBookingObjectSummaryVDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedReadingResultOfBookingObjectSummaryVDTO>(null as any);
    }
}

export interface IBookingObjectRemovalRequestClient {
    create(requestDTO: CreateBookingObjectRemovalRequestRequestDTO): Promise<ControllerActionResultOfGuid>;
    confirm(requestDTO: ConfirmBookingObjectRemovalRequestRequestDTO): Promise<EmptyControllerActionResult>;
    read(): Promise<BookingObjectRemovalRequestVDTO[]>;
}

export class BookingObjectRemovalRequestClient implements IBookingObjectRemovalRequestClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";

    }

    create(requestDTO: CreateBookingObjectRemovalRequestRequestDTO , cancelToken?: CancelToken | undefined): Promise<ControllerActionResultOfGuid> {
        let url_ = this.baseUrl + "/booking-object/removal-request/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ControllerActionResultOfGuid> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ControllerActionResultOfGuid>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ControllerActionResultOfGuid>(null as any);
    }

    confirm(requestDTO: ConfirmBookingObjectRemovalRequestRequestDTO , cancelToken?: CancelToken | undefined): Promise<EmptyControllerActionResult> {
        let url_ = this.baseUrl + "/booking-object/removal-request/confirm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConfirm(_response);
        });
    }

    protected processConfirm(response: AxiosResponse): Promise<EmptyControllerActionResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EmptyControllerActionResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyControllerActionResult>(null as any);
    }

    read(  cancelToken?: CancelToken | undefined): Promise<BookingObjectRemovalRequestVDTO[]> {
        let url_ = this.baseUrl + "/booking-object/removal-request/read";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRead(_response);
        });
    }

    protected processRead(response: AxiosResponse): Promise<BookingObjectRemovalRequestVDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BookingObjectRemovalRequestVDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingObjectRemovalRequestVDTO[]>(null as any);
    }
}

export interface IBookingObjectSummaryClient {
    onTop(requestDTO: ReadOnTopBookingObjectSummariesRequestDTO): Promise<BookingObjectSummaryVDTO[]>;
    forSelecting(requestDTO: ReadBookingObjectSummariesForSelectingRequestDTO): Promise<BookingObjectSummaryForSelectingVDTO[]>;
    forReviewCreating(requestDTO: ReadBookingObjectSummariesForReviewCreatingRequestDTO): Promise<BookingObjectSummaryForReviewCreatingVDTO[]>;
    forConversation(requestDTO: ReadBookingObjectSummariesForConversationRequestDTO): Promise<BookingObjectSummaryForConversationVDTO[]>;
    forRemovalRequestManagement(requestDTO: ReadBookingObjectSummariesForRemovalRequestManagementRequestDTO): Promise<BookingObjectSummaryForRemovalRequestManagementVDTO[]>;
}

export class BookingObjectSummaryClient implements IBookingObjectSummaryClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";

    }

    onTop(requestDTO: ReadOnTopBookingObjectSummariesRequestDTO , cancelToken?: CancelToken | undefined): Promise<BookingObjectSummaryVDTO[]> {
        let url_ = this.baseUrl + "/booking-object/summary/on-top";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOnTop(_response);
        });
    }

    protected processOnTop(response: AxiosResponse): Promise<BookingObjectSummaryVDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BookingObjectSummaryVDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingObjectSummaryVDTO[]>(null as any);
    }

    forSelecting(requestDTO: ReadBookingObjectSummariesForSelectingRequestDTO , cancelToken?: CancelToken | undefined): Promise<BookingObjectSummaryForSelectingVDTO[]> {
        let url_ = this.baseUrl + "/booking-object/summary/for-selecting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processForSelecting(_response);
        });
    }

    protected processForSelecting(response: AxiosResponse): Promise<BookingObjectSummaryForSelectingVDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BookingObjectSummaryForSelectingVDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingObjectSummaryForSelectingVDTO[]>(null as any);
    }

    forReviewCreating(requestDTO: ReadBookingObjectSummariesForReviewCreatingRequestDTO , cancelToken?: CancelToken | undefined): Promise<BookingObjectSummaryForReviewCreatingVDTO[]> {
        let url_ = this.baseUrl + "/booking-object/summary/for-review-creating";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processForReviewCreating(_response);
        });
    }

    protected processForReviewCreating(response: AxiosResponse): Promise<BookingObjectSummaryForReviewCreatingVDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BookingObjectSummaryForReviewCreatingVDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingObjectSummaryForReviewCreatingVDTO[]>(null as any);
    }

    forConversation(requestDTO: ReadBookingObjectSummariesForConversationRequestDTO , cancelToken?: CancelToken | undefined): Promise<BookingObjectSummaryForConversationVDTO[]> {
        let url_ = this.baseUrl + "/booking-object/summary/for-conversation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processForConversation(_response);
        });
    }

    protected processForConversation(response: AxiosResponse): Promise<BookingObjectSummaryForConversationVDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BookingObjectSummaryForConversationVDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingObjectSummaryForConversationVDTO[]>(null as any);
    }

    forRemovalRequestManagement(requestDTO: ReadBookingObjectSummariesForRemovalRequestManagementRequestDTO , cancelToken?: CancelToken | undefined): Promise<BookingObjectSummaryForRemovalRequestManagementVDTO[]> {
        let url_ = this.baseUrl + "/booking-object/summary/for-removal-request-management";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processForRemovalRequestManagement(_response);
        });
    }

    protected processForRemovalRequestManagement(response: AxiosResponse): Promise<BookingObjectSummaryForRemovalRequestManagementVDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BookingObjectSummaryForRemovalRequestManagementVDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingObjectSummaryForRemovalRequestManagementVDTO[]>(null as any);
    }
}

export interface IArticleClient {
    create(requestDTO: CreateArticleRequestDTO): Promise<ControllerActionResultOfGuid>;
    update(requestDTO: UpdateArticleRequestDTO): Promise<EmptyControllerActionResult>;
    remove(requestDTO: DeleteArticleRequestDTO): Promise<EmptyControllerActionResult>;
    read(requestDTO: ReadArticlesRequestDTO): Promise<ArticleVDTO[]>;
    readSingle(requestDTO: ReadArticleRequestDTO): Promise<ArticleVDTO>;
}

export class ArticleClient implements IArticleClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";

    }

    create(requestDTO: CreateArticleRequestDTO , cancelToken?: CancelToken | undefined): Promise<ControllerActionResultOfGuid> {
        let url_ = this.baseUrl + "/administration/cms/article/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ControllerActionResultOfGuid> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ControllerActionResultOfGuid>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ControllerActionResultOfGuid>(null as any);
    }

    update(requestDTO: UpdateArticleRequestDTO , cancelToken?: CancelToken | undefined): Promise<EmptyControllerActionResult> {
        let url_ = this.baseUrl + "/administration/cms/article/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<EmptyControllerActionResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EmptyControllerActionResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyControllerActionResult>(null as any);
    }

    remove(requestDTO: DeleteArticleRequestDTO , cancelToken?: CancelToken | undefined): Promise<EmptyControllerActionResult> {
        let url_ = this.baseUrl + "/administration/cms/article/remove";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: AxiosResponse): Promise<EmptyControllerActionResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EmptyControllerActionResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyControllerActionResult>(null as any);
    }

    read(requestDTO: ReadArticlesRequestDTO , cancelToken?: CancelToken | undefined): Promise<ArticleVDTO[]> {
        let url_ = this.baseUrl + "/administration/cms/article/read";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRead(_response);
        });
    }

    protected processRead(response: AxiosResponse): Promise<ArticleVDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ArticleVDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArticleVDTO[]>(null as any);
    }

    readSingle(requestDTO: ReadArticleRequestDTO , cancelToken?: CancelToken | undefined): Promise<ArticleVDTO> {
        let url_ = this.baseUrl + "/administration/cms/article/read-single";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadSingle(_response);
        });
    }

    protected processReadSingle(response: AxiosResponse): Promise<ArticleVDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ArticleVDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArticleVDTO>(null as any);
    }
}

export interface IBookingObjectModeratingClient {
    approve(requestDTO: ApproveBookingObjectRequestDTO): Promise<EmptyControllerActionResult>;
    reject(requestDTO: RejectBookingObjectRequestDTO): Promise<EmptyControllerActionResult>;
    read(): Promise<BookingObjectSummaryForModeratingViewDTO[]>;
}

export class BookingObjectModeratingClient implements IBookingObjectModeratingClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";

    }

    approve(requestDTO: ApproveBookingObjectRequestDTO , cancelToken?: CancelToken | undefined): Promise<EmptyControllerActionResult> {
        let url_ = this.baseUrl + "/administration/booking-object-moderation/approve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApprove(_response);
        });
    }

    protected processApprove(response: AxiosResponse): Promise<EmptyControllerActionResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EmptyControllerActionResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyControllerActionResult>(null as any);
    }

    reject(requestDTO: RejectBookingObjectRequestDTO , cancelToken?: CancelToken | undefined): Promise<EmptyControllerActionResult> {
        let url_ = this.baseUrl + "/administration/booking-object-moderation/reject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReject(_response);
        });
    }

    protected processReject(response: AxiosResponse): Promise<EmptyControllerActionResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EmptyControllerActionResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyControllerActionResult>(null as any);
    }

    read(  cancelToken?: CancelToken | undefined): Promise<BookingObjectSummaryForModeratingViewDTO[]> {
        let url_ = this.baseUrl + "/administration/booking-object-moderation/read";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRead(_response);
        });
    }

    protected processRead(response: AxiosResponse): Promise<BookingObjectSummaryForModeratingViewDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BookingObjectSummaryForModeratingViewDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingObjectSummaryForModeratingViewDTO[]>(null as any);
    }
}

export interface IBookingObjectReviewManagementClient {
    create(request: CreateBookingObjectReviewRequestDTO): Promise<EmptyControllerActionResult>;
    update(request: UpdateBookingObjectReviewRequestDTO): Promise<EmptyControllerActionResult>;
    delete(request: DeleteBookingObjectReviewRequestDTO): Promise<EmptyControllerActionResult>;
    readById(requestDTO: ReadBookingObjectReviewByIdRequestDTO): Promise<BookingObjectReviewVDTO>;
}

export class BookingObjectReviewManagementClient implements IBookingObjectReviewManagementClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";

    }

    create(request: CreateBookingObjectReviewRequestDTO , cancelToken?: CancelToken | undefined): Promise<EmptyControllerActionResult> {
        let url_ = this.baseUrl + "/administration/booking-object-review-management/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<EmptyControllerActionResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EmptyControllerActionResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyControllerActionResult>(null as any);
    }

    update(request: UpdateBookingObjectReviewRequestDTO , cancelToken?: CancelToken | undefined): Promise<EmptyControllerActionResult> {
        let url_ = this.baseUrl + "/administration/booking-object-review-management/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<EmptyControllerActionResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EmptyControllerActionResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyControllerActionResult>(null as any);
    }

    delete(request: DeleteBookingObjectReviewRequestDTO , cancelToken?: CancelToken | undefined): Promise<EmptyControllerActionResult> {
        let url_ = this.baseUrl + "/administration/booking-object-review-management/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<EmptyControllerActionResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EmptyControllerActionResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyControllerActionResult>(null as any);
    }

    readById(requestDTO: ReadBookingObjectReviewByIdRequestDTO , cancelToken?: CancelToken | undefined): Promise<BookingObjectReviewVDTO> {
        let url_ = this.baseUrl + "/administration/booking-object-review-management/read-by-id";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadById(_response);
        });
    }

    protected processReadById(response: AxiosResponse): Promise<BookingObjectReviewVDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BookingObjectReviewVDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingObjectReviewVDTO>(null as any);
    }
}

export interface IBusinessModelManagementClient {
    updateBusinessModelParameter(requestDTO: UpdateBusinessModelParameterRequestDTO): Promise<EmptyControllerActionResult>;
}

export class BusinessModelManagementClient implements IBusinessModelManagementClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";

    }

    updateBusinessModelParameter(requestDTO: UpdateBusinessModelParameterRequestDTO , cancelToken?: CancelToken | undefined): Promise<EmptyControllerActionResult> {
        let url_ = this.baseUrl + "/administration/business-model-management/update-business-model-parameter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateBusinessModelParameter(_response);
        });
    }

    protected processUpdateBusinessModelParameter(response: AxiosResponse): Promise<EmptyControllerActionResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EmptyControllerActionResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyControllerActionResult>(null as any);
    }
}

export interface IDashboardClient {
    metrics(): Promise<ProductMetricVDTO[]>;
    operational(request: OperationalDashboardRequestVDTO): Promise<OperationalDashboardVDTO>;
}

export class DashboardClient implements IDashboardClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";

    }

    metrics(  cancelToken?: CancelToken | undefined): Promise<ProductMetricVDTO[]> {
        let url_ = this.baseUrl + "/administration/dashboard/metrics";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMetrics(_response);
        });
    }

    protected processMetrics(response: AxiosResponse): Promise<ProductMetricVDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProductMetricVDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductMetricVDTO[]>(null as any);
    }

    operational(request: OperationalDashboardRequestVDTO, cancelToken?: CancelToken | undefined): Promise<OperationalDashboardVDTO> {
        let url_ = this.baseUrl + "/administration/dashboard/operational";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperational(_response);
        });
    }

    protected processOperational(response: AxiosResponse): Promise<OperationalDashboardVDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<OperationalDashboardVDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationalDashboardVDTO>(null as any);
    }
}

export interface IMailingClient {
    create(requestDTO: CreateMailingRequestDTO): Promise<EmptyControllerActionResult>;
    start(requestDTO: StartMailingRequestDTO): Promise<EmptyControllerActionResult>;
    read(requestDTO: ReadMailingsRequestDTO): Promise<MailingVDTO[]>;
}

export class MailingClient implements IMailingClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";

    }

    create(requestDTO: CreateMailingRequestDTO , cancelToken?: CancelToken | undefined): Promise<EmptyControllerActionResult> {
        let url_ = this.baseUrl + "/administration/mailing/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<EmptyControllerActionResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EmptyControllerActionResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyControllerActionResult>(null as any);
    }

    start(requestDTO: StartMailingRequestDTO , cancelToken?: CancelToken | undefined): Promise<EmptyControllerActionResult> {
        let url_ = this.baseUrl + "/administration/mailing/start";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStart(_response);
        });
    }

    protected processStart(response: AxiosResponse): Promise<EmptyControllerActionResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EmptyControllerActionResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyControllerActionResult>(null as any);
    }

    read(requestDTO: ReadMailingsRequestDTO , cancelToken?: CancelToken | undefined): Promise<MailingVDTO[]> {
        let url_ = this.baseUrl + "/administration/mailing/read";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRead(_response);
        });
    }

    protected processRead(response: AxiosResponse): Promise<MailingVDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MailingVDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MailingVDTO[]>(null as any);
    }
}

export interface IMetadataUploadingClient {
    createCountryRegion(requestDTO: CreateCountryRegionRequestDTO): Promise<FileResponse>;
    createCountryRegionCitiesFromExcel(countryRegionId?: number | undefined, countryRegionCitiesFile?: FileParameter | null | undefined): Promise<FileResponse>;
    createaCountryRegionCity(requestDTO: CreateCountryRegionCityRequestDTO): Promise<FileResponse>;
    updateCountryRegionCity(requestDTO: UpdateCountryRegionCityRequestDTO): Promise<FileResponse>;
    addressMetadata(addressMetadataFile?: FileParameter | null | undefined): Promise<FileResponse>;
    timezones(timezonesFile?: FileParameter | null | undefined): Promise<FileResponse>;
    languages(languagesFile?: FileParameter | null | undefined): Promise<FileResponse>;
    currencies(currenciesFile?: FileParameter | null | undefined, withOverwriting?: boolean | undefined): Promise<FileResponse>;
    countryCurrencies(countryCurrenciesFile?: FileParameter | null | undefined): Promise<FileResponse>;
    countryCodes(countryCodesFile?: FileParameter | null | undefined): Promise<FileResponse>;
    businessModelParameters(businessModelParametersFile?: FileParameter | null | undefined): Promise<FileResponse>;
}

export class MetadataUploadingClient implements IMetadataUploadingClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";

    }

    createCountryRegion(requestDTO: CreateCountryRegionRequestDTO , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/administration/metadata-uploading/create-country-region";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCountryRegion(_response);
        });
    }

    protected processCreateCountryRegion(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    createCountryRegionCitiesFromExcel(countryRegionId?: number | undefined, countryRegionCitiesFile?: FileParameter | null | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/administration/metadata-uploading/create-country-region-cities-from-excel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (countryRegionId === null || countryRegionId === undefined)
            throw new Error("The parameter 'countryRegionId' cannot be null.");
        else
            content_.append("countryRegionId", countryRegionId.toString());
        if (countryRegionCitiesFile !== null && countryRegionCitiesFile !== undefined)
            content_.append("countryRegionCitiesFile", countryRegionCitiesFile.data, countryRegionCitiesFile.fileName ? countryRegionCitiesFile.fileName : "countryRegionCitiesFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCountryRegionCitiesFromExcel(_response);
        });
    }

    protected processCreateCountryRegionCitiesFromExcel(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    createaCountryRegionCity(requestDTO: CreateCountryRegionCityRequestDTO , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/administration/metadata-uploading/createa-country-region-city";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateaCountryRegionCity(_response);
        });
    }

    protected processCreateaCountryRegionCity(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    updateCountryRegionCity(requestDTO: UpdateCountryRegionCityRequestDTO , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/administration/metadata-uploading/update-country-region-city";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCountryRegionCity(_response);
        });
    }

    protected processUpdateCountryRegionCity(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    addressMetadata(addressMetadataFile?: FileParameter | null | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/administration/metadata-uploading/address-metadata";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (addressMetadataFile !== null && addressMetadataFile !== undefined)
            content_.append("addressMetadataFile", addressMetadataFile.data, addressMetadataFile.fileName ? addressMetadataFile.fileName : "addressMetadataFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddressMetadata(_response);
        });
    }

    protected processAddressMetadata(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    timezones(timezonesFile?: FileParameter | null | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/administration/metadata-uploading/timezones";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (timezonesFile !== null && timezonesFile !== undefined)
            content_.append("timezonesFile", timezonesFile.data, timezonesFile.fileName ? timezonesFile.fileName : "timezonesFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTimezones(_response);
        });
    }

    protected processTimezones(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    languages(languagesFile?: FileParameter | null | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/administration/metadata-uploading/languages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (languagesFile !== null && languagesFile !== undefined)
            content_.append("languagesFile", languagesFile.data, languagesFile.fileName ? languagesFile.fileName : "languagesFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLanguages(_response);
        });
    }

    protected processLanguages(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    currencies(currenciesFile?: FileParameter | null | undefined, withOverwriting?: boolean | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/administration/metadata-uploading/currencies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (currenciesFile !== null && currenciesFile !== undefined)
            content_.append("currenciesFile", currenciesFile.data, currenciesFile.fileName ? currenciesFile.fileName : "currenciesFile");
        if (withOverwriting === null || withOverwriting === undefined)
            throw new Error("The parameter 'withOverwriting' cannot be null.");
        else
            content_.append("withOverwriting", withOverwriting.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCurrencies(_response);
        });
    }

    protected processCurrencies(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    countryCurrencies(countryCurrenciesFile?: FileParameter | null | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/administration/metadata-uploading/country-currencies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (countryCurrenciesFile !== null && countryCurrenciesFile !== undefined)
            content_.append("countryCurrenciesFile", countryCurrenciesFile.data, countryCurrenciesFile.fileName ? countryCurrenciesFile.fileName : "countryCurrenciesFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCountryCurrencies(_response);
        });
    }

    protected processCountryCurrencies(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    countryCodes(countryCodesFile?: FileParameter | null | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/administration/metadata-uploading/country-codes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (countryCodesFile !== null && countryCodesFile !== undefined)
            content_.append("countryCodesFile", countryCodesFile.data, countryCodesFile.fileName ? countryCodesFile.fileName : "countryCodesFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCountryCodes(_response);
        });
    }

    protected processCountryCodes(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    businessModelParameters(businessModelParametersFile?: FileParameter | null | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/administration/metadata-uploading/business-model-parameters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (businessModelParametersFile !== null && businessModelParametersFile !== undefined)
            content_.append("businessModelParametersFile", businessModelParametersFile.data, businessModelParametersFile.fileName ? businessModelParametersFile.fileName : "businessModelParametersFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBusinessModelParameters(_response);
        });
    }

    protected processBusinessModelParameters(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IUserManagementClient {
    updateEmail(requestDTO: UpdateEmailRequestDTO): Promise<EmptyControllerActionResult>;
    updatePhoneNumber(requestDTO: UpdatePhoneNumberRequestDTO): Promise<EmptyControllerActionResult>;
    readByFilterPaged(requestDTO: ReadUsersByFilterPagedRequestDTO): Promise<PagedReadingResultOfUserReadVDTO>;
}

export class UserManagementClient implements IUserManagementClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5000";

    }

    updateEmail(requestDTO: UpdateEmailRequestDTO , cancelToken?: CancelToken | undefined): Promise<EmptyControllerActionResult> {
        let url_ = this.baseUrl + "/administration/user-management/update-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateEmail(_response);
        });
    }

    protected processUpdateEmail(response: AxiosResponse): Promise<EmptyControllerActionResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EmptyControllerActionResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyControllerActionResult>(null as any);
    }

    updatePhoneNumber(requestDTO: UpdatePhoneNumberRequestDTO , cancelToken?: CancelToken | undefined): Promise<EmptyControllerActionResult> {
        let url_ = this.baseUrl + "/administration/user-management/update-phone-number";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePhoneNumber(_response);
        });
    }

    protected processUpdatePhoneNumber(response: AxiosResponse): Promise<EmptyControllerActionResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EmptyControllerActionResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyControllerActionResult>(null as any);
    }

    readByFilterPaged(requestDTO: ReadUsersByFilterPagedRequestDTO , cancelToken?: CancelToken | undefined): Promise<PagedReadingResultOfUserReadVDTO> {
        let url_ = this.baseUrl + "/administration/user-management/read-by-filter-paged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadByFilterPaged(_response);
        });
    }

    protected processReadByFilterPaged(response: AxiosResponse): Promise<PagedReadingResultOfUserReadVDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PagedReadingResultOfUserReadVDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedReadingResultOfUserReadVDTO>(null as any);
    }
}

export interface ControllerActionResultOfBeginPaymentResponseDTO {
    Ok?: boolean;
    Result?: BeginPaymentResponseDTO | null;
    ErrorMessages?: string[];
    HasErrors?: boolean;
}

export interface BeginPaymentResponseDTO {
    PaymentUrl?: string;
}

export interface BeginPaymentForBookingCreatingRequestDTO {
    BookingId?: string;
}

export interface HasBillingOrderBeenPaidResponseDTO {
    HasBeenPaid?: boolean;
}

export interface HasBillingOrderBeenPaidRequestDTO {
    MerchantBillingOrderId?: string;
}

export interface BillingOrderSummaryVDTO {
    BillingOrderId?: string;
    BookingNumber?: number;
    BookingObjectId?: string;
    BookingObjectName?: string;
    BookingObjectNumber?: number;
}

export interface ReadBillingOrderSummaryRequestDTO {
    BillingOrderNumber?: number;
}

export interface ControllerActionResultOfGuid {
    Ok?: boolean;
    Result?: string;
    ErrorMessages?: string[];
    HasErrors?: boolean;
}

export interface ControllerActionResultOfInt32 {
    Ok?: boolean;
    Result?: number;
    ErrorMessages?: string[];
    HasErrors?: boolean;
}

export interface CreateBookingObjectCalendarRequestDTO {
    BookingObjectId?: string;
}

export interface CloseDatesRequestDTO {
    BookingObjectHostId?: string;
    BookingObjectPremiseId?: string | null;
    DateStart?: Date;
    DateFinish?: Date;
    PremiseCount?: number | null;
    InternalComment?: string | null;
}

export interface EmptyControllerActionResult {
    Ok?: boolean;
    ErrorMessages?: string[];
    HasErrors?: boolean;
}

export interface UpdateClosedDatesEventRequestDTO {
    BookingObjectHostId?: string;
    BookingObjectPremiseId?: string | null;
    BookingObjectCalendarEventId?: string;
    DateStart?: Date;
    DateFinish?: Date;
    PremiseCount?: number | null;
    InternalComment?: string;
}

export interface DeleteBookingObjectCalendarEventRequestDTO {
    BookingObjectCalendarEventId?: string;
}

export interface IsSynchronizationSetUpRequestDTO {
    BookingObjectId?: string;
}

export interface BookingObjectCalendarVDTO {
    Id?: string;
    BookingObjectId?: string;
    ExternalSources?: BookingObjectCalendarExternalSourceVDTO[];
    Events?: BookingObjectCalendarEventVDTO[];
}

export interface BookingObjectCalendarExternalSourceVDTO {
    Id?: string;
    BookingObjectCalendarId?: string;
    Name?: string | null;
    DateTimeLastSynchronization?: Date | null;
    Format?: BookingObjectCalendarExternalSourceFormatEnum;
    ExternalSourceUrl?: string;
    Status?: BookingObjectCalendarExternalSourceStatusEnum;
    SynchronizationErrors?: BookingObjectOccupancySynchronizationErrorVDTO[];
}

export enum BookingObjectCalendarExternalSourceFormatEnum {
    Unset = 0,
    ICS = 1,
}

export enum BookingObjectCalendarExternalSourceStatusEnum {
    Unset = 0,
    Validating = 1,
    Working = 2,
    ServerError = 3,
    StoppedDueToErrorSource = 4,
}

export interface BookingObjectOccupancySynchronizationErrorVDTO {
    Id?: string;
    BookingObjectCalendarExternalSourceId?: string;
    DateTimeCreated?: Date;
    Error?: string;
}

export interface BookingObjectCalendarEventVDTO {
    Id?: string;
    BookingObjectCalendarId?: string;
    BookingObjectCalendarExternalSourceId?: string | null;
    Summary?: string | null;
    Description?: string | null;
    DateStart?: Date;
    DateFinish?: Date;
    PremiseCount?: number | null;
    Status?: BookingObjectCalendarEventStatusEnum;
}

export enum BookingObjectCalendarEventStatusEnum {
    Unset = 0,
    Unknown = 1,
    Tentative = 2,
    Confirmed = 3,
    Cancelled = 4,
    Internal_Closed = 5,
}

export interface ReadCalendarForBookingObjectRequestDTO {
    BookingObjectId?: string;
}

export interface ReadCalendarsForBookingObjectsRequestDTO {
    BookingObjectIds?: string[];
}

export interface BookingObjectCalendarStateVDTO {
    Id?: string;
    BookingObjectId?: string;
    DateTimeCreated?: Date;
    ExternalSources?: BookingObjectCalendarExternalSourceVDTO[];
}

export interface ReadBookingObjectCalendarStatesRequestDTO {
    Filter?: OccupancySynchronizationFilterEnum;
    BookingObjectIds?: string[];
    PagingOptions?: PagingOptionsDTO;
}

export interface PagedReadingResultOfBookingObjectCalendarStateVDTO {
    Data?: BookingObjectCalendarStateVDTO[] | null;
    PageNumber?: number;
    PageSize?: number;
    PagesCount?: number;
}

export interface OccupancySynchronizationStatisticsVDTO {
    NotConfiguredCount?: number;
    StableCount?: number;
    PartiallyStableCount?: number;
    WithErrorsCount?: number;
}

export enum OccupancySynchronizationFilterEnum {
    Unset = 0,
    All = 1,
    NotConfigured = 2,
    Stable = 3,
    PartiallyStable = 4,
    WithErrors = 5,
    HasErrors = 6,
}

export interface CreateBookingObjectCalendarExternalSourceRequestDTO {
    Name?: string | null;
    ExternalSourceUrl?: string;
    BookingObjectCalendarId?: string;
    Format?: BookingObjectCalendarExternalSourceFormatEnum;
}

export interface DeleteBookingObjectCalendarExternalSourceRequestDTO {
    BookingObjectCalendarExternalSourceId?: string;
}

export interface ReactivateBookingObjectCalendarExternalSourceRequestDTO {
    BookingObjectCalendarExternalSourceId?: string;
}

export interface ControllerActionResultOfBookingObjectCreateResultVDTO {
    Ok?: boolean;
    Result?: BookingObjectCreateResultVDTO | null;
    ErrorMessages?: string[];
    HasErrors?: boolean;
}

export interface BookingObjectCreateResultVDTO {
    BookingObjectId?: string;
    BookingObjectPremiseIds?: string[];
}

export interface CreateBookingObjectOptionsDTO {
    UserId?: string | null;
    BookingObject?: BookingObjectDTO;
}

export interface BookingObjectDTO {
    Id?: string | null;
    UserId?: string | null;
    Number?: number | null;
    CurrencyId?: number;
    Status?: BookingObjectStatusEnum;
    HostBookingObjectId?: string | null;
    StarsClassification?: number | null;
    Premises?: BookingObjectDTO[];
    PremiseType?: BookingObjectPremiseTypeEnum;
    PremiseCount?: number;
    Rooms?: BookingObjectRoomDTO[];
    Parkings?: BookingObjectParkingDTO[];
    Fees?: BookingObjectFeeDTO[];
    Name?: string;
    Description?: string;
    InternalTimeZoneId?: number;
    TimeArrival?: string;
    TimeDeparture?: string;
    MinimumHoursToCheckIn?: number;
    MinimumStayInDays?: number;
    MinimumDaysToCancelBooking?: number;
    BookingType?: BookingTypeEnum;
    AvailableBookingPaymentTypes?: BookingPaymentTypeEnum[];
    InsuranceDeposit?: PriceVO;
    Photos?: BookingObjectPhotoDTO[];
    Category?: BookingObjectCategoryEnum | null;
    BeddingCategoryType?: BookingObjectBeddingCategoryTypeEnum | null;
    ApartmentCategoryType?: BookingObjectApartmentCategoryTypeEnum | null;
    HouseCategoryType?: BookingObjectHouseCategoryTypeEnum | null;
    RoomCategoryType?: BookingObjectRoomCategoryTypeEnum | null;
    CountryId?: number;
    CountryRegionId?: number;
    CountryRegionCityId?: number;
    StreetAddress?: string;
    Latitude?: number | null;
    Longitude?: number | null;
    MaximumGuestsCount?: number;
    RoomsCount?: number;
    BedroomsCount?: number;
    BathroomsWithToiletCount?: number;
    BathroomsWithoutToiletsCount?: number;
    ToiletsCount?: number;
    TotalAreaInSqM?: number | null;
    FloorNumber?: number | null;
    TotalFloors?: number | null;
    IsElevatorExist?: boolean | null;
    KitchenType?: BookingObjectKitchenTypeEnum | null;
    RenovationType?: BookingObjectRenovationTypeEnum | null;
    RulesOfPlacement?: BookingObjectRulesOfPlacementDTO | null;
    Breakfast?: BookingObjectBreakfastDTO | null;
    BedsList?: BookingObjectBedTypeEnum[];
    StaffProficiencyLanguageIds?: number[];
    BeddingFeatures?: BookingObjectBeddingFeaturesEnum[];
    BathroomFeaturesList?: BookingObjectBathroomFeaturesEnum[];
    ChildrenFeaturesList?: BookingObjectChildrenFeaturesEnum[];
    CommonFeaturesList?: BookingObjectCommonFeaturesEnum[];
    ConvenienceFeaturesList?: BookingObjectConvenienceFeaturesEnum[];
    KitchenFeaturesList?: BookingObjectKitchenFeaturesEnum[];
    RelaxFeaturesList?: BookingObjectRelaxFeaturesEnum[];
    ViewFromWindowsList?: BookingObjectViewFromWindowsEnum[];
    IsFavorite?: boolean;
}

export enum BookingObjectStatusEnum {
    Unset = 0,
    Draft = 1,
    Moderating = 2,
    NeedClarification = 3,
    Active = 4,
    Blocked = 5,
    Deleted = 6,
    RemovalRequestModerating = 7,
}

export enum BookingObjectPremiseTypeEnum {
    Unset = 0,
    Single = 1,
    Double = 2,
    Triple = 3,
    Quadruple = 4,
    Family = 5,
    Suite = 6,
    StudioRoom = 7,
    Apartment = 8,
    CommonRoom = 9,
    CommonRoomBed = 10,
}

export interface BookingObjectRoomDTO {
    Id?: string | null;
    BookingObjectId?: string | null;
    Type?: BookingObjectRoomTypeEnum;
    Beds?: BookingObjectBedTypeEnum[];
    SortOrder?: number;
}

export enum BookingObjectRoomTypeEnum {
    Unset = 0,
    Bathroom = 1,
    Bedroom = 2,
    LivingRoom = 3,
    Kitchen = 4,
}

export enum BookingObjectBedTypeEnum {
    Unset = 0,
    SingleBed = 1,
    DoubleBed = 2,
    DoubleWideBed = 3,
    DoubleOverWideBed = 4,
    BunkBed = 5,
    SofaBed = 6,
    ArmchairBed = 7,
}

export interface BookingObjectParkingDTO {
    Id?: string | null;
    Name?: string;
    Type?: BookingObjectParkingTypeEnum;
    Location?: BookingObjectParkingLocationEnum;
    UsageType?: BookingObjectParkingUsageTypeEnum;
    PlaceBookingType?: BookingObjectParkingPlaceBookingTypeEnum;
    PaymentType?: BookingObjectParkingPaymentTypeEnum;
    Price?: PriceVO;
    PriceDescription?: string | null;
    CarHeightRestriction?: number | null;
    ParkingServicesExistence?: boolean;
    ParkingStaffExistence?: boolean;
}

export enum BookingObjectParkingTypeEnum {
    Unset = 0,
    Internal = 1,
    Public = 2,
    Street = 3,
}

export enum BookingObjectParkingLocationEnum {
    Unset = 0,
    Inside = 1,
    Outside = 2,
}

export enum BookingObjectParkingUsageTypeEnum {
    Unset = 0,
    Private = 1,
    Shared = 2,
}

export enum BookingObjectParkingPlaceBookingTypeEnum {
    Unset = 0,
    Required = 1,
    NotRequired = 2,
    Impossible = 3,
}

export enum BookingObjectParkingPaymentTypeEnum {
    Unset = 0,
    NeedFee = 1,
    Free = 2,
    PossibleNeedFee = 3,
}

export interface ValueObject {
}

export interface PriceVO extends ValueObject {
    CurrencyId?: number;
    Value?: number | null;
}

export interface BookingObjectFeeDTO {
    Id?: string | null;
    Type?: BookingObjectFeeTypeEnum;
    IsIncludedInCost?: boolean;
    Cost?: PriceVO;
}

export enum BookingObjectFeeTypeEnum {
    Unset = 0,
    ServiceCharge = 1,
    ResortFee = 2,
    CleaningFee = 3,
    TowelFee = 4,
    ElectricityFee = 5,
    BedLinenFee = 6,
    GasFee = 7,
    FuelFee = 8,
    WoodFee = 9,
    WaterUsageFee = 10,
    LocalTax = 11,
    EnvironmentalFee = 12,
    SpaAccessFee = 13,
    TransferFee = 14,
}

export enum BookingTypeEnum {
    Unset = 0,
    Instant = 1,
    ByRequest = 2,
}

export enum BookingPaymentTypeEnum {
    Unset = 0,
    OnlinePrepayment = 1,
    Cash = 2,
}

export interface BookingObjectPhotoDTO {
    Id?: string | null;
    FileId?: string;
    Name?: string | null;
    PublicUrl?: string | null;
    IsMain?: boolean;
    SortOrder?: number;
}

export enum BookingObjectCategoryEnum {
    Unset = 0,
    Bedding = 1,
    Apartment = 2,
    Home = 3,
    Room = 4,
}

export enum BookingObjectBeddingCategoryTypeEnum {
    Unset = 0,
    Hotel = 1,
    MiniHotel = 2,
    GuestHouse = 3,
    Aparthotel = 4,
    Hostel = 5,
    EconomyClassHotel = 6,
    CapsuleHotel = 7,
    HolidayHome = 8,
    HolidayHotel = 9,
    Sanatorium = 10,
    Apartment = 11,
    FurnishedRoom = 12,
}

export enum BookingObjectApartmentCategoryTypeEnum {
    Unset = 0,
    Flat = 1,
    Apartment = 2,
    StudioFlat = 3,
}

export enum BookingObjectHouseCategoryTypeEnum {
    Unset = 0,
    Cottage = 1,
    House = 2,
    Villa = 3,
    PartOfHouseWithSeparateEntrance = 4,
    Boathouse = 5,
    VillageHouse = 6,
    Townhouse = 7,
    WholeFloor = 8,
    Guesthouse = 9,
    Chalet = 10,
    Bungalow = 11,
    Motorhome = 12,
    Mansion = 13,
    Yacht = 14,
    SummerHouse = 15,
}

export enum BookingObjectRoomCategoryTypeEnum {
    Unset = 0,
    InApartment = 1,
    InPrivateHouse = 2,
    InCottage = 3,
}

export enum BookingObjectKitchenTypeEnum {
    Unset = 0,
    Separate = 1,
    KitchenDiningRoom = 2,
    KitchenArea = 3,
    Missing = 4,
}

export enum BookingObjectRenovationTypeEnum {
    Unset = 0,
    Missing = 1,
    Cosmetic = 2,
    Euro = 3,
    Design = 4,
    Granny = 5,
}

export interface BookingObjectRulesOfPlacementDTO {
    Id?: string | null;
    AreGuestsWithAnimalsAcceptable?: boolean;
    AreGuestsWithChildrenAcceptable?: boolean;
    ChildrenMinimumAge?: number | null;
    IsSmokingAcceptable?: boolean;
    IsPartyingAcceptable?: boolean;
}

export interface BookingObjectBreakfastDTO {
    Id?: string | null;
    BookingObjectId?: string | null;
    IsAvailable?: boolean;
    IsIncludedInResidenceCost?: boolean;
    BreakfastFullCost?: PriceVO;
    Types?: BookingObjectBreakfastTypeEnum[];
}

export enum BookingObjectBreakfastTypeEnum {
    Americans = 0,
    Unset = 0,
    ByMenu = 1,
    Asian = 3,
    BreakfastToGo = 4,
    Buffet = 5,
    Continental = 6,
    TraditionalIrishOrAnglican = 7,
    GlutenFree = 8,
    Halal = 9,
    Italian = 10,
    Kosher = 11,
    Vegan = 12,
    Vegetarian = 13,
}

export enum BookingObjectBeddingFeaturesEnum {
    Unset = 0,
    Bar = 1,
    Sauna = 2,
    Garden = 3,
    Terrace = 4,
    Jacuzzi = 5,
    Heating = 6,
    WiFi = 7,
    AirConditioning = 8,
    Pool = 9,
}

export enum BookingObjectBathroomFeaturesEnum {
    Unset = 0,
    Bidet = 1,
    Bathtub = 2,
    HygienicShower = 3,
    Shower = 4,
    Towels = 5,
    Sauna = 6,
    Slippers = 7,
    Toiletries = 8,
    Hairdryer = 9,
    Bathrobe = 10,
}

export enum BookingObjectChildrenFeaturesEnum {
    Unset = 0,
    HighChair = 1,
    Crib = 2,
    Potty = 3,
    WindowGuards = 4,
    GamesAndToys = 5,
    CribBed = 6,
    ChangingTable = 7,
    HighChairForFeeding = 8,
}

export enum BookingObjectCommonFeaturesEnum {
    Unset = 0,
    Fan = 1,
    WaterHeater = 2,
    GasWaterHeater = 3,
    WalkInCloset = 4,
    SeatingArea = 5,
    HardwoodFlooring = 6,
    Jacuzzi = 7,
    Intercom = 8,
    CoffeeTable = 9,
    SoundProofing = 10,
    Fireplace = 11,
    Carpeting = 12,
    AirConditioning = 13,
    Laminate = 14,
    Linoleum = 15,
    MetalDoor = 16,
    MosquitoNet = 17,
    Heater = 18,
    ElectricHeatedBlankets = 19,
    PC = 20,
    TileMarbleFloor = 21,
    WiredInternet = 22,
    WorkDesk = 23,
    RollawayBed = 24,
    Safe = 25,
    WashingMachine = 26,
    ClothesDryer = 27,
    TumbleDryer = 28,
    IronAndIroningBoard = 29,
    CentralHeating = 30,
    CleaningProducts = 31,
    Cupboard = 32,
}

export enum BookingObjectConvenienceFeaturesEnum {
    Unset = 0,
    Balcony = 1,
    WiFiInternet = 2,
    BedLinen = 3,
    TV = 4,
}

export enum BookingObjectKitchenFeaturesEnum {
    Unset = 0,
    Bar = 1,
    Blender = 2,
    GasStove = 3,
    Oven = 4,
    CoffeeMaker = 5,
    CoffeeMachine = 6,
    KitchenUnit = 7,
    MiniBar = 8,
    Freezer = 9,
    Multicooker = 10,
    DiningTable = 11,
    KitchenwareAndAccessories = 12,
    Dishwasher = 13,
    MicrowaveOven = 14,
    Cutlery = 15,
    Toaster = 16,
    Turk = 17,
    WaterFilter = 18,
    Fridge = 19,
    ElectricKettle = 20,
    ElectricStove = 21,
}

export enum BookingObjectRelaxFeaturesEnum {
    Unset = 0,
    CompactDiscPlayer = 1,
    CompactDiscs = 2,
    Billiard = 3,
    GameConsole = 4,
    Books = 5,
    SoundSystem = 6,
    BoardGames = 7,
    TableTennis = 8,
    Laptop = 9,
    Radio = 10,
    YoutubeOnTV = 11,
}

export enum BookingObjectViewFromWindowsEnum {
    Unset = 0,
    AtSea = 1,
    Mountains = 2,
    OnTheTown = 3,
    OnTheRiver = 4,
    OnTheLake = 5,
    AtTheForest = 6,
    Park = 7,
    Outside = 8,
    IntoCourtyard = 9,
}

export interface ControllerActionResultOfBookingObjectUpdateResultVDTO {
    Ok?: boolean;
    Result?: BookingObjectUpdateResultVDTO | null;
    ErrorMessages?: string[];
    HasErrors?: boolean;
}

export interface BookingObjectUpdateResultVDTO {
    BookingObjectId?: string;
    BookingObjectPremiseCreatedIds?: string[];
    BookingObjectPremiseUpdatedIds?: string[];
    BookingObjectPremiseDeletedIds?: string[];
}

export interface UpdateBookingObjectDTO {
    BookingObject?: BookingObjectDTO;
}

export interface ActivateBookingObjectRequestDTO {
    BookingObjectId?: string;
}

export interface ManageBookingTypeRequestDTO {
    BookingObjectId?: string;
    BookingType?: BookingTypeEnum;
}

export interface BookingObjectCapacityResponseDTO {
    MaximumGuestsCount?: number;
}

export interface ReadBookingObjectCapacityRequestDTO {
    BookingObjectId?: string;
}

export interface BookingObjectSummaryForOccupancyScheduleVDTO {
    BookingObjectHostId?: string;
    BookingObjectHostNumber?: number;
    BookingObjectHostName?: string;
    BookingObjectHostCategory?: BookingObjectCategoryEnum;
    PremiseIds?: string[];
    BookingObjectPremiseId?: string | null;
    BookingObjectPremiseType?: BookingObjectPremiseTypeEnum | null;
    BookingObjectPremiseCount?: number | null;
    CountryId?: number;
    CountryRegionId?: number;
    CountryRegionCityId?: number;
    CurrencyId?: number;
    StreetAddress?: string;
    PreviewPhotoFileUrl?: string;
    TimeArrival?: string;
    TimeDeparture?: string;
    InternalTimeZoneId?: number;
    BedsCount?: number;
    BedroomsCount?: number;
    MaximumGuestsCount?: number;
}

export interface ReadBookingObjectSummaryForOccupancyScheduleRequestDTO {
    BookingObjectId?: string;
}

export interface ReadBookingObjectSummariesForOccupancyScheduleRequestDTO {
    BookingObjectIds?: string[];
}

export interface BookingObjectSummaryForPricePolicyManagementVDTO {
    BookingObjectId?: string;
    CurrencyId?: number;
    MaximumGuestsCount?: number;
}

export interface ReadBookingObjectSummaryForPricePolicyManagementRequestDTO {
    BookingObjectId?: string;
}

export interface BookingObjectSummaryVDTO {
    Id?: string;
    Number?: number;
    Name?: string;
    Premises?: BookingObjectPremiseSummaryVDTO[];
    Status?: BookingObjectStatusEnum;
    Category?: BookingObjectCategoryEnum | null;
    StarsClassification?: number | null;
    BeddingCategoryType?: BookingObjectBeddingCategoryTypeEnum | null;
    ApartmentCategoryType?: BookingObjectApartmentCategoryTypeEnum | null;
    HouseCategoryType?: BookingObjectHouseCategoryTypeEnum | null;
    RoomCategoryType?: BookingObjectRoomCategoryTypeEnum | null;
    PreviewPhotoUrl?: string;
    CountryId?: number;
    CountryRegionId?: number;
    CountryRegionCityId?: number;
    StreetAddress?: string;
    Beds?: BookingObjectBedTypeEnum[];
    Rating?: number;
    LastRejection?: BookingObjectSummaryLastRejectionViewDTO | null;
    MinimumPrice?: PriceVO;
    Latitude?: number | null;
    Longitude?: number | null;
    MinimumDaysToCancelBooking?: number;
    BookingType?: BookingTypeEnum;
    IsBreakfastAvailable?: boolean | null;
    IsBreakfastIncludedInCost?: boolean | null;
    IsFavorite?: boolean;
}

export interface BookingObjectPremiseSummaryVDTO {
    Id?: string;
    Number?: number;
    Count?: number;
    Name?: string;
    Type?: BookingObjectPremiseTypeEnum;
    Status?: BookingObjectStatusEnum;
    PreviewPhotoUrl?: string;
    Rating?: number;
    Beds?: BookingObjectBedTypeEnum[];
    Rooms?: BookingObjectRoomTypeEnum[];
    MinimumPrice?: PriceVO;
}

export interface BookingObjectSummaryLastRejectionViewDTO {
    DateTimeCreated?: Date;
    RejectionReason?: string;
}

export interface ReadBookingObjectSummariesForUserRequestDTO {
    UserId?: string;
}

export interface ReadBookingObjectSummaryForFavoritesRequestDTO {
    BookingObjectIds?: string[];
}

export interface BookingObjectsForUserVDTO {
    ServiceProvider?: BookingObjectOwnerVDTO;
    BookingObjects?: BookingObjectSummaryVDTO[];
}

export interface BookingObjectOwnerVDTO {
    FirstName?: string;
    AvatarUrl?: string | null;
    ProficiencyLanguageIds?: number[];
}

export interface ReadBookingObjectsForUserRequestDTO {
    PublicUserId?: string;
}

export interface BookingObjectStructureVDTO {
    HostBookingObjectId?: string;
    PremiseIds?: string[];
}

export interface ReadBookingObjectsStructureForUserRequestDTO {
    UserId?: string;
}

export interface CreateBookingObjectPricePolicyRequestDTO {
    PricePolicy?: CreateBookingObjectPricePolicy_PricePolicy_RequestDTO;
}

export interface CreateBookingObjectPricePolicy_PricePolicy_RequestDTO {
    BookingObjectId?: string;
    DateStart?: Date | null;
    DateFinish?: Date | null;
    Type?: BookingObjectPricePolicyTypeEnum;
    DefaultPrice?: PriceVO;
    AdditionalFeeForEachGuestAboveFullOccupation?: PriceVO;
    TermsForGuests?: CreateBookingObjectPricePolicy_PricePolicyItem_RequestDTO[];
}

export enum BookingObjectPricePolicyTypeEnum {
    Unset = 0,
    FixedPrice = 1,
    ByGuestsCount = 2,
}

export interface CreateBookingObjectPricePolicy_PricePolicyItem_RequestDTO {
    GuestsCount?: number;
    ReductionType?: BookingObjectPricePolicyReductionTypeEnum;
    PriceReductionInMoney?: PriceVO;
    PriceReductionInPercents?: number | null;
}

export enum BookingObjectPricePolicyReductionTypeEnum {
    Unset = 0,
    Money = 1,
    Percent = 2,
}

export interface UpdateBookingObjectPricePolicyRequestDTO {
    PricePolicy?: UpdateBookingObjectPricePolicy_PricePolicyDTO_RequestDTO;
}

export interface UpdateBookingObjectPricePolicy_PricePolicyDTO_RequestDTO {
    Id?: string;
    BookingObjectId?: string;
    DateStart?: Date | null;
    DateFinish?: Date | null;
    Type?: BookingObjectPricePolicyTypeEnum;
    DefaultPrice?: PriceVO;
    AdditionalFeeForEachGuestAboveFullOccupation?: PriceVO;
    TermsForGuests?: UpdateBookingObjectPricePolicy_PricePolicyItemDTO_RequestDTO[];
}

export interface UpdateBookingObjectPricePolicy_PricePolicyItemDTO_RequestDTO {
    Id?: string | null;
    GuestsCount?: number;
    ReductionType?: BookingObjectPricePolicyReductionTypeEnum;
    PriceReductionInMoney?: PriceVO;
    PriceReductionInPercents?: number | null;
}

export interface DeleteBookingObjectPricePolicyRequestDTO {
    PricePolicyId?: string;
}

export interface BookingObjectPricePolicyVDTO {
    Id?: string;
    BookingObjectId?: string;
    DateTimeUpdated?: Date;
    DateStart?: Date | null;
    DateFinish?: Date | null;
    Type?: BookingObjectPricePolicyTypeEnum;
    DefaultPrice?: PriceVO;
    AdditionalFeeForEachGuestAboveFullOccupation?: PriceVO;
    TermsForGuests?: BookingObjectPricePolicyItemResponseDTO[];
}

export interface BookingObjectPricePolicyItemResponseDTO {
    Id?: string;
    GuestsCount?: number;
    ReductionType?: BookingObjectPricePolicyReductionTypeEnum;
    PriceReductionInMoney?: PriceVO;
    PriceReductionInPercents?: number | null;
}

export interface ReadPricePoliciesForBookingObjectRequestDTO {
    BookingObjectId?: string;
}

export interface ReadBookingObjectPricePoliciesByFilterRequestDTO {
    BookingObjectPricePolicyId?: string | null;
    BookingObjectIds?: string[] | null;
    OnlyDefault?: boolean;
}

export interface BookingObjectMinimumPriceVDTO {
    BookingObjectId?: string;
    MinimumPrice?: PriceVO;
}

export interface ReadMinimumPricesRequestDTO {
    BookingObjectIds?: string[];
}

export interface ControllerActionResultOfBookingCreatingResultResponseDTO {
    Ok?: boolean;
    Result?: BookingCreatingResultResponseDTO | null;
    ErrorMessages?: string[];
    HasErrors?: boolean;
}

export interface BookingCreatingResultResponseDTO {
    BookingId?: string;
    NeedsToBePaid?: boolean;
}

export interface CreateBookingRequestDTO {
    HostBooking?: HostBookingDataRequestDTO;
    PartialBookings?: PartialBookingDataRequestDTO[];
}

export interface HostBookingDataRequestDTO {
    BookingObjectId?: string;
    DateArrival?: Date;
    DateDeparture?: Date;
    ApproximateArrivalTime?: string | null;
    AdultsCount?: number;
    ChildrenCount?: number;
    CostInBookingObjectCurrency?: PriceVO;
    PrepaymentInBookingObjectCurrency?: PriceVO;
    CostInBankAcquirerCurrency?: PriceVO;
    PrepaymentInBankAcquirerCurrency?: PriceVO;
    CostInServiceConsumerCurrency?: PriceVO;
    PrepaymentInServiceConsumerCurrency?: PriceVO;
    PhoneNumber?: string;
    Wishes?: string | null;
    PaymentType?: BookingPaymentTypeEnum;
}

export interface PartialBookingDataRequestDTO {
    BookingObjectId?: string;
    AdultsCount?: number;
    ChildrenCount?: number;
    CostInBookingObjectCurrency?: PriceVO;
    PrepaymentInBookingObjectCurrency?: PriceVO;
    CostInBankAcquirerCurrency?: PriceVO;
    PrepaymentInBankAcquirerCurrency?: PriceVO;
    CostInServiceConsumerCurrency?: PriceVO;
    PrepaymentInServiceConsumerCurrency?: PriceVO;
}

export interface ControllerActionResultOfBoolean {
    Ok?: boolean;
    Result?: boolean;
    ErrorMessages?: string[];
    HasErrors?: boolean;
}

export interface PrevalidateBookingRequestDTO {
    HostBooking?: HostBookingDataRequestDTO2;
    PartialBookings?: PartialBookingDataRequestDTO2[];
}

export interface HostBookingDataRequestDTO2 {
    BookingObjectId?: string;
    DateArrival?: Date;
    DateDeparture?: Date;
    AdultsCount?: number;
    ChildrenCount?: number;
}

export interface PartialBookingDataRequestDTO2 {
    BookingObjectId?: string;
    AdultsCount?: number;
    ChildrenCount?: number;
}

export interface ConfirmBookingRequestDTO {
    BookingId?: string;
}

export interface CancelBookingRequestDTO {
    BookingId?: string;
    WithForceRefunding?: boolean | null;
}

export interface RejectBookingRequestDTO {
    BookingId?: string;
    RejectionReason?: BookingUserRejectionReasonEnum;
}

export enum BookingUserRejectionReasonEnum {
    Unset = 0,
    DatesHaveBeenAlreadyBooked = 1,
    TechnicalWorks = 2,
    CertificationWorks = 3,
    NotReadyToVoiceReason = 4,
    Custom = 5,
}

export interface IsFreeCancellationAllowedResponseDTO {
    IsFreeCancellationAllowed?: boolean;
}

export interface IsFreeCancellationAllowedRequestDTO {
    BookingId?: string;
}

export interface BookingVDTO {
    BookingId?: string;
    PartialBookings?: PartialBookingVDTO[];
    DateTimeCreated?: Date;
    Number?: number;
    ServiceProvider?: ServiceProviderDTO | null;
    ServiceConsumer?: ServiceConsumerDTO | null;
    BookingObject?: BookingReadVDTO_HostBookingObjectVDTO;
    Status?: BookingStatusEnum;
    PaymentStatus?: BookingPaymentStatusEnum;
    CancellationType?: BookingCancellationTypeEnum | null;
    DateArrival?: Date;
    DateDeparture?: Date;
    BookingType?: BookingTypeEnum;
    BookingPaymentType?: BookingPaymentTypeEnum;
    AproximateArrivalTime?: string | null;
    CostInBookingObjectCurrency?: PriceVO;
    PrepaymentInBookingObjectCurrency?: PriceVO;
    CostInBankAcquirerCurrency?: PriceVO;
    PrepaymentInBankAcquirerCurrency?: PriceVO;
    CostInServiceConsumerCurrency?: PriceVO;
    PrepaymentInServiceConsumerCurrency?: PriceVO;
    MinimumDaysToCancelBooking?: number;
    AdultsCount?: number;
    ChildrenCount?: number;
    Wishes?: string | null;
    RejectionType?: BookingRejectionTypeEnum | null;
    AutomaticRejectionReason?: BookingAutomaticRejectionReasonEnum | null;
    UserRejectionReason?: BookingUserRejectionReasonEnum | null;
    RejectionReasonCustomText?: string | null;
    BookingRequestConfirmationDeadline?: Date | null;
}

export interface PartialBookingVDTO {
    BookingId?: string;
    BookingObject?: BookingReadVDTO_PremiseBookingObjectVDTO;
    CostInBookingObjectCurrency?: PriceVO;
    PrepaymentInBookingObjectCurrency?: PriceVO;
    CostInBankAcquirerCurrency?: PriceVO;
    PrepaymentInBankAcquirerCurrency?: PriceVO;
    CostInServiceConsumerCurrency?: PriceVO;
    PrepaymentInServiceConsumerCurrency?: PriceVO;
    AdultsCount?: number;
    ChildrenCount?: number;
}

export interface BookingReadVDTO_PremiseBookingObjectVDTO {
    Id?: string;
    PremiseType?: BookingObjectPremiseTypeEnum;
    Beds?: BookingObjectBedTypeEnum[];
    Rooms?: BookingObjectRoomTypeEnum[];
}

export interface ServiceProviderDTO {
    Id?: string;
    FirstName?: string;
    LastName?: string;
    Email?: string;
    PhoneNumber?: string;
    AvatarPath?: string | null;
}

export interface ServiceConsumerDTO {
    Id?: string;
    FirstName?: string;
    LastName?: string;
    Email?: string;
    PhoneNumber?: string;
    AvatarPath?: string | null;
}

export interface BookingReadVDTO_HostBookingObjectVDTO {
    Id?: string;
    Number?: number;
    Name?: string;
    PreviewPhotoPath?: string;
    CountryId?: number;
    CountryRegionId?: number;
    CountryRegionCityId?: number;
    FullAddress?: string;
    InternalTimezoneId?: number;
}

export enum BookingStatusEnum {
    Unset = 0,
    Reserved = 1,
    Confirmed = 2,
    Cancelled = 3,
    Rejected = 4,
    Deleted = 5,
}

export enum BookingPaymentStatusEnum {
    Unset = 0,
    NotApplicable = 1,
    WaitingForPayment = 2,
    MoneyReservedAndWaitingForConfirmation = 3,
    Paid = 4,
    WaitingForRefunding = 5,
    Refunded = 6,
    RefundingIsNotAllowedDueToFreeCancellationTimeframeIsExceeded = 7,
    Rejected = 8,
}

export enum BookingCancellationTypeEnum {
    Unset = 0,
    Automatically = 1,
    ByAdministrator = 2,
    ByServiceProvider = 3,
    ByServiceConsumer = 4,
}

export enum BookingRejectionTypeEnum {
    Unset = 0,
    Automatic = 1,
    ByUser = 2,
}

export enum BookingAutomaticRejectionReasonEnum {
    Unset = 0,
    PrepaymentIsNotMadeOnTime = 1,
    BookingIsUnavailableOnSelectedDates = 2,
    BookingRequestConfirmationPeriodExceeded = 3,
}

export interface ReadBookingByIdRequestDTO {
    BookingId?: string;
}

export interface ReadBookingsForBookingObjectRequestDTO {
    BookingObjectId?: string;
}

export interface ReadBookingsForBookingObjectsRequestDTO {
    BookingObjectIds?: string[];
}

export interface PagedReadingResultOfBookingVDTO {
    Data?: BookingVDTO[] | null;
    PageNumber?: number;
    PageSize?: number;
    PagesCount?: number;
}

export interface ReadBookingsByFilterPagedRequestDTO {
    Filter?: BookingFilterRequestDTO;
    PagingOptions?: PagingOptionsDTO;
}

export interface BookingFilterRequestDTO {
    BookingObjectIds?: string[];
    BookingNumbers?: number[];
}

export interface PagingOptionsDTO {
    PageNumber?: number;
    PageSize?: number;
    Ignore?: boolean;
}

export interface BookingCostBuildingResultVDTO {
    BookingObjectHostId?: string;
    FeeCalculationDetails?: FeeCalculationDetailItemVDTO[];
    ResidenceConfiguration?: ResidenceConfigurationItemVDTO[];
    TotalCost?: PriceVO;
    Prepayment?: PriceVO;
}

export interface FeeCalculationDetailItemVDTO {
    Cost?: PriceVO;
    IsIncludedInCost?: boolean;
    Type?: BookingObjectFeeTypeEnum;
}

export interface ResidenceConfigurationItemVDTO {
    BookingObjectId?: string;
    CostDetails?: BookingCostDetailsVDTO;
    GuestsCount?: number;
}

export interface BookingCostDetailsVDTO {
    BookingObjectId?: string;
    Cost?: PriceVO;
    NormalizedCost?: PriceVO;
    FeeCalculationDetails?: FeeCalculationDetailItemVDTO[];
    ResidenceCalculationDetails?: ResidenceCalculationDetailItemVDTO[];
}

export interface ResidenceCalculationDetailItemVDTO {
    DateStart?: Date;
    DateFinish?: Date;
    Amount?: PriceVO;
    GuestsCount?: number;
}

export interface PrebuildBookingPricesRequestDTO {
    BookingObjectIds?: string[];
    DateArrival?: Date;
    DateDeparture?: Date;
    AdultsCount?: number;
    ChildrenCount?: number;
}

export interface BuildBookingCostRequestDTO {
    BookingObjectId?: string;
    DateArrival?: Date;
    DateDeparture?: Date;
    AdultsCount?: number;
    ChildrenCount?: number;
    PaymentType?: BookingPaymentTypeEnum;
    ResidenceConfiguration?: BuildBookingCostRequestDTO_ResidenceConfigurationItemToCalculateDTO[] | null;
}

export interface BuildBookingCostRequestDTO_ResidenceConfigurationItemToCalculateDTO {
    BookingObjectHostId?: string;
    BookingObjectPremiseId?: string;
    AdultsCount?: number;
    ChildrenCount?: number;
}

export interface BookingBusinessModelParametersVDTO {
    BookingCommissionInPercents?: number;
    MaximumDurationOfBookingRequestProcessingInSeconds?: number;
    MaximumDurationOfPrepaymentFinishingInSeconds?: number;
    MaximumDurationOfPrepaymentDelayBeforeNotification?: number;
    IsNotifyingByForeignPhoneNumbersEnabled?: boolean;
    IsCashPaymentEnabled?: boolean;
    IsSmsNotificationsEnabled?: boolean;
    HostBookingRequestReminderScheduleFractions?: number[];
    MaximumOccupancySyncFailuresInARow?: number;
}

export interface ControllerActionResultOfConversationMessageVDTO {
    Ok?: boolean;
    Result?: ConversationMessageVDTO | null;
    ErrorMessages?: string[];
    HasErrors?: boolean;
}

export interface ConversationMessageVDTO {
    Id?: string;
    ConversationId?: string;
    SenderUserId?: string | null;
    DateTimeCreated?: Date;
    DateTimeUpdated?: Date;
    MessageContent?: string;
    ReadForUserIds?: string[];
    TargetUserIds?: string[] | null;
    Type?: ConversationMessageTypeEnum;
}

export enum ConversationMessageTypeEnum {
    Unset = 0,
    FromUser = 1,
    FromSystem = 2,
}

export interface SendMessageRequestDTO {
    ConversationId?: string;
    MessageContent?: string;
}

export interface MarkConversationMessagesAsReadForUserRequestDTO {
    ConversationId?: string;
    ConversationMessageIds?: string[];
}

export interface ConversationSummaryForUserVDTO {
    Conversation?: ConversationVDTO;
    UnreadMessagesCount?: number;
}

export interface ConversationVDTO {
    Id?: string;
    BookingId?: string | null;
    DateTimeCreated?: Date;
    DateTimeUpdated?: Date;
    ParticipantUserIds?: string[];
}

export interface ReadConversationSummariesForUserRequestDTO {
}

export interface ReadConversationMessagesPartitionedRequestDTO {
    ConversationId?: string;
    PartitioningOptions?: PartitioningOptionsRequestDTOOfConversationMessagePartitioningFeaturesVO;
}

export interface PartitioningOptionsRequestDTOOfConversationMessagePartitioningFeaturesVO {
    Features?: ConversationMessagePartitioningFeaturesVO;
    Size?: number;
}

export interface ConversationMessagePartitioningFeaturesVO extends ValueObject {
    ConversationMessageId?: string | null;
}

export interface ReadUnreadMessagesCountRequestDTO {
}

export interface ReadBookingRelatedConversationIdRequestDTO {
    BookingId?: string;
}

export interface ExchangeRateVDTO {
    Id?: string;
    DateTimeCreated?: Date;
    TargetCurrencyId?: number;
    Nominal?: number;
    Value?: number;
}

export interface CreateFavoriteRequestDTO {
    BookingObjectId?: string;
}

export interface RemoveFavoriteRequestDTO {
    BookingObjectId?: string;
}

export interface PagedReadingResultOfUserFavoriteVDTO {
    Data?: UserFavoriteVDTO[] | null;
    PageNumber?: number;
    PageSize?: number;
    PagesCount?: number;
}

export interface UserFavoriteVDTO {
    DateTimeCreated?: Date;
    BookingObjectId?: string;
}

export interface ReadUserFavoritesPagedRequestDTO {
    PagingOptions?: PagingOptionsRequestDTO;
}

export interface PagingOptionsRequestDTO {
    PageNumber?: number;
    PageSize?: number;
}

export interface FilesUploadingResult {
    FileIds?: string[];
}

export interface FileUploadingResultVDTO {
    FileId?: string;
    Url?: string;
}

export interface UserAvatarUploadingResultVDTO {
    FileId?: string;
}

export interface BookingObjectPhotosUploadingResultVDTO {
    Photos?: BookingObjectPhotosUploadingResultItemVDTO[];
}

export interface BookingObjectPhotosUploadingResultItemVDTO {
    FileId?: string;
    PublicUrl?: string;
}

export interface CountryVDTO {
    Id?: number;
    Name?: string;
    Code?: string;
    CurrencyId?: number;
    Regions?: CountryRegionVDTO[];
}

export interface CountryRegionVDTO {
    Id?: number;
    Name?: string;
    Cities?: CountryRegionCityVDTO[];
}

export interface CountryRegionCityVDTO {
    Id?: number;
    Name?: string;
    Latitude?: number;
    Longitude?: number;
    IANATimeZoneId?: string;
    IANATimeZoneBaseUTCOffset?: string;
    InternalTimezoneId?: number;
}

export interface CurrencyVDTO {
    Id?: number;
    Name?: string;
    CharCode?: string;
}

export interface TimezoneReadDTO {
    Id?: number;
    Name?: string;
    UTCOffset?: string;
}

export interface LanguageReadDTO {
    Id?: number;
    Name?: string;
}

export interface SynchronizeOccupancyScheduleRequestDTO {
    BookingObjectId?: string;
}

export interface CreateBookingObjectClientReviewRequestDTO {
    BookingId?: string;
    BookingObjectId?: string;
    Score?: number;
    Text?: string | null;
    ScoreCategories?: CreateBookingObjectClientReviewRequestDTO_ScoreCategoryRequestDTO[];
}

export interface CreateBookingObjectClientReviewRequestDTO_ScoreCategoryRequestDTO {
    Category?: BookingObjectReviewScoreCategoryEnum;
    Score?: number;
}

export enum BookingObjectReviewScoreCategoryEnum {
    Unset = 0,
    Staff = 1,
    Comfort = 2,
    WiFi = 3,
    Conveniences = 4,
    PriceQualityRatio = 5,
    Cleanness = 6,
    Location = 7,
}

export interface CalculateBookingObjectScoreResponseDTO {
    Score?: number;
}

export interface CalculateBookingObjectScoreRequestDTO {
    BookingObjectId?: string;
}

export interface BookingObjectReviewPublicSummaryVDTO {
    Id?: string;
    Booking?: BookingObjectReviewPublicSummaryVDTO_BookingSummaryVDTO | null;
    Reviewer?: BookingObjectReviewPublicSummaryVDTO_ReviewerSummaryVDTO | null;
    Source?: BookingObjectReviewSourceEnum;
    BookingObjectId?: string;
    BookingObjectName?: string;
    DateTimeCreated?: Date;
    DateTimeUpdated?: Date;
    Text?: string | null;
    ScoreCategories?: BookingObjectReviewPublicSummaryVDTO_ScoreCategoryVDTO[];
    Score?: number;
    Status?: BookingObjectReviewStatusEnum;
}

export interface BookingObjectReviewPublicSummaryVDTO_BookingSummaryVDTO {
    BookingId?: string;
    DateArrival?: Date;
    DateDeparture?: Date;
}

export interface BookingObjectReviewPublicSummaryVDTO_ReviewerSummaryVDTO {
    Id?: string;
    FirstName?: string;
    LastName?: string;
    AvatarPath?: string | null;
}

export enum BookingObjectReviewSourceEnum {
    Unset = 0,
    Own = 1,
    BookingCom = 2,
    Airbnb = 3,
}

export interface BookingObjectReviewPublicSummaryVDTO_ScoreCategoryVDTO {
    Id?: string;
    Category?: BookingObjectReviewScoreCategoryEnum;
    Score?: number;
}

export enum BookingObjectReviewStatusEnum {
    Unset = 0,
    Moderating = 1,
    Active = 2,
    ModerationFailed = 3,
    Deleted = 4,
}

export interface ReadLastReviewsRequestDTO {
    ReviewsCount?: number;
}

export interface PagedReadingResultOfBookingObjectReviewPublicSummaryVDTO {
    Data?: BookingObjectReviewPublicSummaryVDTO[] | null;
    PageNumber?: number;
    PageSize?: number;
    PagesCount?: number;
}

export interface ReadBookingObjectReviewsRequestDTO {
    BookingObjectIds?: string[];
    PagingOptions?: PagingOptionsDTO;
}

export interface SendSupportRequestDTO {
    Email?: string;
    Message?: string;
}

export interface UserSummaryForMailingVDTO {
    Id?: string;
    Roles?: UserTypeEnum[];
    FirstName?: string;
    LastName?: string;
    Email?: string;
    PhoneNumber?: string;
    MainRole?: UserTypeEnum;
}

export enum UserTypeEnum {
    Unset = 0,
    ServiceProvider = 1,
    ServiceConsumer = 2,
    SystemAdministrator = 3,
    SystemManager = 4,
}

export interface ChangePasswordRequestDTO {
    OldPassword?: string;
    NewPassword?: string;
}

export interface SendRestorePasswordApplicationDTO {
    Email?: string;
}

export interface ResetPasswordRequestDTO {
    Email?: string;
    ResetToken?: string;
    NewPassword?: string;
}

export interface UpdateUserInformationRequestDTO {
    UserId?: string;
    AvatarFileId?: string | null;
    About?: string | null;
    PreferredTimeZoneId?: number | null;
    ProficiencyLanguageIds?: number[];
    ShowOnlyFirstNameOnBookingObjectView?: boolean;
    Passport?: UpdateUserInformation_Passport_RequestDTO;
}

export interface UpdateUserInformation_Passport_RequestDTO {
    FirstName?: string;
    LastName?: string;
    Patronymic?: string | null;
    Gender?: GenderAssignmentEnum;
    DateOfBirth?: Date | null;
    ResidenceAddress?: string | null;
    SeriesAndNumber?: string | null;
    IssuerCode?: string | null;
    IssueDate?: Date | null;
}

export enum GenderAssignmentEnum {
    Unset = 0,
    Male = 1,
    Female = 2,
}

export interface ControllerActionResultOfLoginResponseDTO {
    Ok?: boolean;
    Result?: LoginResponseDTO | null;
    ErrorMessages?: string[];
    HasErrors?: boolean;
}

export interface LoginResponseDTO {
    Token?: string | null;
    NeedsToConfirmEmail?: boolean;
}

export interface LoginRequestDTO {
    Password?: string | null;
    UserName?: string | null;
}

export interface ControllerActionResultOfRegisterResponseDTO {
    Ok?: boolean;
    Result?: RegisterResponseDTO | null;
    ErrorMessages?: string[];
    HasErrors?: boolean;
}

export interface RegisterResponseDTO {
}

export interface RegisterRequestDTO {
    FirstName?: string | null;
    LastName?: string | null;
    Email?: string | null;
    PhoneNumber?: string | null;
    Password?: string | null;
    Type?: UserTypeEnum;
    IsPersonalDataProcessingAgreementSigned?: boolean;
    ReturnUrl?: string | null;
}

export interface ControllerActionResultOfCurrentUserDataResponseDTO {
    Ok?: boolean;
    Result?: CurrentUserDataResponseDTO | null;
    ErrorMessages?: string[];
    HasErrors?: boolean;
}

export interface CurrentUserDataResponseDTO {
    UserId?: string;
    PublicUserId?: string;
    RoleIds?: UserTypeEnum[];
    MainRole?: UserTypeEnum;
    Passport?: CurrentUserPassportDataResponseDTO;
    Email?: string;
    PhoneNumber?: string;
    AvatarFileId?: string | null;
    AvatarFilePath?: string | null;
    About?: string | null;
    PreferredTimeZoneId?: number | null;
    ProficiencyLanguageIds?: number[];
    ShowOnlyFirstNameOnBookingObjectView?: boolean;
}

export interface CurrentUserPassportDataResponseDTO {
    FirstName?: string;
    LastName?: string;
    Patronymic?: string | null;
    Gender?: GenderAssignmentEnum;
    DateOfBirth?: Date | null;
    SeriesAndNumber?: string | null;
    IssuerCode?: string | null;
    IssueDate?: Date | null;
    ResidenceAddress?: string | null;
}

export interface UserPublicDataResponseDTO {
    Id?: string;
    FirstName?: string;
    LastName?: string;
    AvatarFileUrl?: string | null;
    About?: string | null;
    ProficiencyLanguageIds?: number[];
    ShowOnlyFirstNameOnBookingObjectView?: boolean;
}

export interface ReadUserPublicDataRequestDTO {
    UserId?: string;
}

export interface UserSummaryForConversationVDTO {
    Id?: string;
    FirstName?: string;
    LastName?: string;
    AvatarFileUrl?: string | null;
    DisplayOnlyFirstName?: boolean;
}

export interface ReadUserSummariesForConversationRequestDTO {
    UserIds?: string[];
}

export interface BookingSummaryForConversationVDTO {
    BookingId?: string;
    BookingObjectId?: string;
    Number?: number;
    DateArrival?: Date;
    DateDeparture?: Date;
    Status?: BookingStatusEnum;
}

export interface ReadBookingSummariesForConversationRequestDTO {
    BookingIds?: string[];
}

export interface PagedReadingResultOfBookingObjectSummaryVDTO {
    Data?: BookingObjectSummaryVDTO[] | null;
    PageNumber?: number;
    PageSize?: number;
    PagesCount?: number;
}

export interface ReadBookingObjectsByFilterPagedRequestDTO {
    Filter?: BookingObjectFilterRequestDTO;
    PagingOptions?: PagingOptionsDTO;
}

export interface BookingObjectFilterRequestDTO {
    CountryId?: number | null;
    CountryRegionId?: number | null;
    CountryRegionCityId?: number | null;
    Name?: string | null;
    DateArrival?: Date | null;
    DateDeparture?: Date | null;
    PricePer24HMin?: PriceVO;
    PricePer24HMax?: PriceVO;
    AdultsCount?: number;
    ChildrenCount?: number | null;
    IsParkingRequired?: boolean;
    IsWiFiRequired?: boolean;
    Category?: BookingObjectCategoryEnum | null;
    BeddingType?: BookingObjectBeddingCategoryTypeEnum | null;
    ApartmentType?: BookingObjectApartmentCategoryTypeEnum | null;
    HouseType?: BookingObjectHouseCategoryTypeEnum | null;
    RoomType?: BookingObjectRoomCategoryTypeEnum | null;
    KitchenType?: BookingObjectKitchenTypeEnum | null;
    RenovationType?: BookingObjectRenovationTypeEnum | null;
    BedTypes?: BookingObjectBedTypeEnum[];
    CommonFeatures?: BookingObjectCommonFeaturesEnum[];
}

export interface CreateBookingObjectRemovalRequestRequestDTO {
    BookingObjectId?: string;
    Reason?: string;
}

export interface ConfirmBookingObjectRemovalRequestRequestDTO {
    BookingObjectRemovalRequestId?: string;
}

export interface BookingObjectRemovalRequestVDTO {
    Id?: string;
    BookingObjectId?: string;
    DateTimeCreated?: Date;
    Reason?: string;
}

export interface ReadOnTopBookingObjectSummariesRequestDTO {
    Count?: number;
}

export interface BookingObjectSummaryForSelectingVDTO {
    Id?: string;
    Name?: string;
    Number?: number;
    Premises?: BookingObjectPremiseSummaryForSelectingVDTO[];
}

export interface BookingObjectPremiseSummaryForSelectingVDTO {
    Id?: string;
    Number?: number;
    Count?: number;
    Name?: string;
    Type?: BookingObjectPremiseTypeEnum;
    Beds?: BookingObjectBedTypeEnum[];
    Rooms?: BookingObjectRoomTypeEnum[];
}

export interface ReadBookingObjectSummariesForSelectingRequestDTO {
}

export interface BookingObjectSummaryForReviewCreatingVDTO {
    Id?: string;
    Name?: string;
    Number?: number;
}

export interface ReadBookingObjectSummariesForReviewCreatingRequestDTO {
}

export interface BookingObjectSummaryForConversationVDTO {
    Id?: string;
    InternalTimezoneId?: number;
    PreviewPhotoFileUrl?: string;
    Number?: number;
    Name?: string;
}

export interface ReadBookingObjectSummariesForConversationRequestDTO {
    BookingObjectIds?: string[];
}

export interface BookingObjectSummaryForRemovalRequestManagementVDTO {
    Id?: string;
    Name?: string;
    Number?: number;
}

export interface ReadBookingObjectSummariesForRemovalRequestManagementRequestDTO {
    BookingObjectIds?: string[];
}

export interface CreateArticleRequestDTO {
    Name?: string;
    Key?: string;
    HumanReadableKey?: string;
    ContentJson?: string;
}

export interface UpdateArticleRequestDTO {
    Id?: string;
    Name?: string;
    Key?: string;
    HumanReadableKey?: string;
    ContentJson?: string;
}

export interface DeleteArticleRequestDTO {
    Id?: string;
}

export interface ArticleVDTO {
    Id?: string;
    DateTimeCreated?: Date;
    DateTimeUpdated?: Date;
    Name?: string;
    Key?: string;
    HumanReadableKey?: string;
    ContentJson?: string;
}

export interface ReadArticlesRequestDTO {
}

export interface ReadArticleRequestDTO {
    Id?: string | null;
    Key?: string | null;
    HumanReadableKey?: string | null;
}

export interface ApproveBookingObjectRequestDTO {
    BookingObjectId?: string;
}

export interface RejectBookingObjectRequestDTO {
    BookingObjectId?: string;
    RejectionReason?: string;
}

export interface BookingObjectSummaryForModeratingViewDTO {
    BookingObjectId?: string;
    Category?: BookingObjectCategoryEnum;
    DateTimeCreated?: Date;
    Name?: string;
}

export interface CreateBookingObjectReviewRequestDTO {
    BookingId?: string | null;
    DateTimeCreated?: Date | null;
    BookingObjectId?: string;
    Source?: BookingObjectReviewSourceEnum;
    Text?: string | null;
    ScoreCategories?: CreateBookingObjectReviewScoreCategoryRequestDTO[];
    Score?: number;
    CustomDetails?: CreateBookingObjectReview_CustomBookingDetails_RequestDTO | null;
}

export interface CreateBookingObjectReviewScoreCategoryRequestDTO {
    Category?: BookingObjectReviewScoreCategoryEnum;
    Score?: number;
}

export interface CreateBookingObjectReview_CustomBookingDetails_RequestDTO {
    DateArrival?: Date;
    DateDeparture?: Date;
    UserFirstName?: string;
    UserLastName?: string;
}

export interface UpdateBookingObjectReviewRequestDTO {
    Id?: string;
    DateTimeCreated?: Date;
    Source?: BookingObjectReviewSourceEnum;
    Text?: string | null;
    ScoreCategories?: UpdateBookingObjectReviewScoreCategoryRequestDTO[];
    Score?: number;
    CustomDetails?: UpdateBookingObjectReview_CustomBookingDetails_RequestDTO | null;
}

export interface UpdateBookingObjectReviewScoreCategoryRequestDTO {
    Id?: string | null;
    Category?: BookingObjectReviewScoreCategoryEnum;
    Score?: number;
}

export interface UpdateBookingObjectReview_CustomBookingDetails_RequestDTO {
    Id?: string;
    BookingObjectReviewId?: string;
    DateArrival?: Date;
    DateDeparture?: Date;
    UserFirstName?: string;
    UserLastName?: string;
}

export interface DeleteBookingObjectReviewRequestDTO {
    BookingObjectReviewId?: string;
}

export interface BookingObjectReviewVDTO {
    Id?: string;
    BookingId?: string | null;
    BookingObjectId?: string;
    DateTimeCreated?: Date;
    DateTimeUpdated?: Date;
    Source?: BookingObjectReviewSourceEnum;
    Text?: string | null;
    ScoreCategories?: BookingObjectReviewVDTO_ScoreCategoryVDTO[];
    Score?: number;
    Status?: BookingObjectReviewStatusEnum;
    CustomDetails?: BookingObjectReviewVDTO_CustomDetailsVDTO | null;
}

export interface BookingObjectReviewVDTO_ScoreCategoryVDTO {
    Id?: string;
    Category?: BookingObjectReviewScoreCategoryEnum;
    Score?: number;
}

export interface BookingObjectReviewVDTO_CustomDetailsVDTO {
    DateArrival?: Date;
    DateDeparture?: Date;
    UserFirstName?: string;
    UserLastName?: string;
}

export interface ReadBookingObjectReviewByIdRequestDTO {
    BookingObjectReviewId?: string;
}

export interface UpdateBusinessModelParameterRequestDTO {
    Id?: BusinessModelParameterIdEnum;
    Group?: BusinessModelParameterGroupEnum;
    SerializedValue?: string;
}

export enum BusinessModelParameterIdEnum {
    Unset = 0,
    BookingCommissionInPercents = 1,
    MaximumDurationOfBookingRequestProcessingInSeconds = 2,
    MaximumDurationOfPrepaymentFinishingInSeconds = 3,
    MaximumDurationOfPrepaymentDelayBeforeNotificationInSeconds = 4,
    IsNotifyingByForeignPhoneNumbersEnabled = 5,
    IsCashPaymentEnabled = 6,
    IsSmsNotificationsEnabled = 7,
    HostBookingRequestReminderScheduleFractions = 8,
    MaximumOccupancySyncFailuresInARow = 9,
}

export enum BusinessModelParameterGroupEnum {
    Unset = 0,
    Booking = 1,
    BookingObject = 2,
    Notification = 3,
    Billing = 4,
    OccupancySchedule = 5,
}

export interface ProductMetricVDTO {
    MetricId?: ProductMetricEnum;
    Value?: number;
}

export enum DashboardDateBasisEnum {
    Unset = 0,
    Created = 1,
    Arrival = 2,
}

export interface OperationalDashboardRequestVDTO {
    DateFrom: string;
    DateTo: string;
    DateBasis: DashboardDateBasisEnum;
}

export interface OperationalBookingStatisticsVDTO {
    CreatedCount: number;
    ReservedCount: number;
    ConfirmedCount: number;
    CancelledCount: number;
    RejectedCount: number;
    ConfirmedUpcomingCount: number;
    ConfirmedCompletedCount: number;
    PaidCount: number;
    WaitingForPaymentCount: number;
    InstantCount: number;
    ByRequestCount: number;
    RejectedByDeadlineCount: number;
    RejectedByHostCount: number;
    AbandonedPaymentCount: number;
    Gmv: number;
    PlatformRevenue: number;
}

export interface OperationalBookingTrendPointVDTO {
    Date: string;
    CreatedCount: number;
    ConfirmedCount: number;
}

export interface OperationalDashboardVDTO {
    DateFrom: string;
    DateTo: string;
    DateBasis: DashboardDateBasisEnum;
    Bookings: OperationalBookingStatisticsVDTO;
    Trend: OperationalBookingTrendPointVDTO[];
    OccupancySynchronization: OccupancySynchronizationStatisticsVDTO;
}

export enum ProductMetricEnum {
    Unset = 0,
    BookingObject_Count = 1,
    BookingObject_HotelsCount = 2,
    BookingObject_HousesCount = 3,
    BookingObject_ApartmentCount = 4,
    Booking_Count = 5,
    User_Count = 6,
    User_ServiceProvidersCount = 7,
    User_ServiceConsumersCount = 8,
    Review_Count = 9,
    FinancialTurnover_Full = 10,
    FinancialTurnover_BookingCommissions = 11,
    FinancialTurnover_CashBookingCommissions = 12,
}

export interface CreateMailingRequestDTO {
    Goal?: string;
    TargetUserIds?: string[];
    Templates?: CreateMailingRequestDTO_MailingTemplateDTO[];
}

export interface CreateMailingRequestDTO_MailingTemplateDTO {
    DeliveryMethod?: NotificationDeliveryMethodEnum;
    TemplateContent?: string;
}

export enum NotificationDeliveryMethodEnum {
    Unset = 0,
    Email = 1,
    SMS = 2,
    Telegram = 3,
    WhatsUp = 4,
    Viber = 5,
    InternalConversation = 6,
}

export interface StartMailingRequestDTO {
    MailingId?: string;
}

export interface MailingVDTO {
    Id?: string;
    DateTimeCreated?: Date;
    Goal?: string;
    TargetUserIds?: string[];
    Templates?: MailingTemplateVDTO[];
    DeliveryMetrics?: MailingNotificationsDeliveryMetricVDTO[];
    Status?: MailingStatusEnum;
}

export interface MailingTemplateVDTO {
    Id?: string;
    DeliveryMethod?: NotificationDeliveryMethodEnum;
    TemplateContent?: string;
}

export interface MailingNotificationsDeliveryMetricVDTO {
    DeliveryMethod?: NotificationDeliveryMethodEnum;
    NotificationsCount?: number;
    NotificationsDeliveredCount?: number;
}

export enum MailingStatusEnum {
    Unset = 0,
    Pending = 1,
    Started = 2,
}

export interface ReadMailingsRequestDTO {
}

export interface CreateCountryRegionRequestDTO {
    CountryId?: number;
    Name?: string;
}

export interface CreateCountryRegionCityRequestDTO {
    CountryRegionId?: number;
    Name?: string;
    Latitude?: number;
    Longitude?: number;
    IANATimeZoneId?: string;
    IANATimeZoneBaseUTCOffset?: string;
    InternalTimezoneId?: number;
}

export interface UpdateCountryRegionCityRequestDTO {
    Id?: number;
    Name?: string;
    Latitude?: number;
    Longitude?: number;
    IANATimeZoneId?: string;
    IANATimeZoneBaseUTCOffset?: string;
    InternalTimezoneId?: number;
}

export interface UpdateEmailRequestDTO {
    UserId?: string;
    Email?: string;
}

export interface UpdatePhoneNumberRequestDTO {
    UserId?: string;
    PhoneNumber?: string;
}

export interface PagedReadingResultOfUserReadVDTO {
    Data?: UserReadVDTO[] | null;
    PageNumber?: number;
    PageSize?: number;
    PagesCount?: number;
}

export interface UserReadVDTO {
    Id?: string;
    PublicId?: string;
    UserName?: string;
    Email?: string;
    PhoneNumber?: string;
    IsEmailConfirmed?: boolean;
    IsPhoneNumberConfirmed?: boolean;
    MainRole?: UserTypeEnum;
    UserIconUrl?: string | null;
    About?: string | null;
    PreferredTimeZoneId?: number | null;
    ProficiencyLanguageIds?: number[];
    IsPersonalDataProcessingAgreementSigned?: boolean;
    ShowOnlyFirstNameOnBookingObjectView?: boolean;
    Passport?: UserPassportReadVDTO;
}

export interface UserPassportReadVDTO {
    Id?: string;
    UserId?: string;
    FirstName?: string;
    LastName?: string;
    Patronymic?: string | null;
    Gender?: GenderAssignmentEnum;
    DateOfBirth?: Date | null;
    SeriesAndNumber?: string | null;
    IssuerCode?: string | null;
    IssueDate?: Date | null;
    ResidenceAddress?: string | null;
}

export interface ReadUsersByFilterPagedRequestDTO {
    Filter?: UserFilterRequestDTO;
    PagingOptions?: PagingOptionsDTO;
}

export interface UserFilterRequestDTO {
    Email?: string | null;
    PhoneNumber?: string | null;
    BookingObjectIds?: string[] | null;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}